// CashierBucket.jsx (FULL FIXED COMPONENT + SPLIT PAYMENT + GIFT CARD REDEEM AS PAYMENT)
// ✅ STRICT ORDER: SOAP sale order → stock decrement → create order → payments → receipt
// ✅ Split payment modal + multiple payment API calls
// ✅ Order create only ONCE
// ✅ Receipts printed (single receipt for split, includes payment breakdown)
// ✅ No Flocash inside split payment
// ✅ Gift Card Redeem is NOT a discount line anymore (frontend does NOT reduce total as discount)
// ✅ Gift Card redeem is handled as PAYMENT (methodId = 11), supports multiple gift cards
// ✅ If gift cards don't cover full total -> auto-opens split payment for remaining

import React, { useState, useEffect, useRef } from 'react';
import '../../Customer/Bucket/bucket.css';
import { ReactComponent as Delete } from '../../assets/images/svgIcons/Delete.svg';
import NoItem from '../../assets/images/empty-cart.png';
import Select from 'react-select';
import { useLocation, useNavigate } from 'react-router-dom';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { ReactComponent as BackArrow } from '../../assets/images/svgIcons/LeftArrow.svg';
import Modal from 'react-bootstrap/Modal';
import './receipt.css';
import './bucket.css';
import PasscodePopup from './PassCode/passCodeModal';
import Calculator from './calculator/calculator';
import { connect, useSelector, useDispatch } from 'react-redux';
import CreatableSelect from 'react-select/creatable';
import { AddToCart, RemoveFromCart, clearCart, downgradeCartItemQuantity, updateCartItemQuantity, setOrderType } from '../../../Redux/actions/cartAction';
import { getAddons, getCartData, getComboData, getTableData, getTaxExplicit, getTaxImplicit, getUserId } from '../../../Redux/selecters';
import { clearTable } from '../../../Redux/actions/tableAction';
import { invokeBroadCastMessage } from '../../services/signalRService';
import DiscountModal from './cashierbucket/addDiscount';
import CustomerCreatePOpup from './createCustomerModal';
import { MdPersonAddAlt1 } from 'react-icons/md';
import userManagement from '../../services/userManagement';
import CartPopup from './cartPopup';
import GiftCardModal from './giftCardModal';
import { BiEdit } from 'react-icons/bi';
import { FaArchive, FaClock, FaMinus, FaPlus, FaReceipt, FaShoppingCart, FaUser } from 'react-icons/fa';
import { TbFlagDiscount } from 'react-icons/tb';
import { HiOutlineTag } from 'react-icons/hi2';
import ReceiptPrintService from '../../services/ReceiptPrintService';
import { setTaxExplicit, setTaxImplicit } from '../../../Redux/actions/taxActions';

// ===================== Stock helper =====================
export const getItemStock = (item) => {
  const toInt = (v) => (v === undefined || v === null || isNaN(parseInt(v)) ? null : parseInt(v));

  const variantStock =
    toInt(item?.selectedVariant?.stockQuantity) ??
    toInt(item?.selectedVariant?.stock) ??
    toInt(item?.selectedVariant?.availableQty) ??
    toInt(item?.selectedVariant?.quantityOnHand);

  const baseStock = toInt(item?.item?.stockQuantity) ?? toInt(item?.item?.stock) ?? toInt(item?.item?.quantityOnHand);

  const topLevelStock = toInt(item?.stockQuantity);

  return variantStock ?? baseStock ?? topLevelStock ?? 0;
};

// ENUM CONSTANTS
const PaymentStatusEnum = {
  Pending: 0,
  Authorized: 1,
  Paid: 2,
  Refunded: 3,
  Failed: 4,
  Initiated: 5,
  Processed: 6,
  Canceled: 7,
  RefundInitiated: 8,
  PartiallyRefunded: 9,
  PartiallyPaid: 10,
};

const OrderStatusEnum = {
  NewOrder: 0,
  Accepted: 1,
  Preparing: 2,
  ReadyForDelivery: 3,
  ReadyForPickup: 4,
  OutForDelivery: 5,
  Completed: 6,
  Canceled: 7,
  Holded: 8,
  RefundInitiated: 9,
  Refunded: 10,
  PaymentPartiallyRefunded: 11,
  PaymentPartiallyPaid: 12,
};

const GIFT_CARD_PAYMENT_METHOD_ID = 11;

const CashierBucket = ({ Currency, handleDisableToggle, Back, onRowSelect, showSearch, menu }) => {
  // Redux selectors
  const cartData = useSelector(getCartData);
  const comboCart = useSelector(getComboData);
  const addOnsCart = useSelector(getAddons);
  const taxImplicit = useSelector(getTaxImplicit);
  let taxExplicit = useSelector(getTaxExplicit);
  const tableData = useSelector(getTableData);
  const userId = useSelector(getUserId);
  const orderTypeR = useSelector((state) => state.cart.orderType);
  const globalDiscount = useSelector((s) => s.cart.globalDiscount);

  useEffect(() => {
    fetchTaxSetting();
  }, []);

  const fetchTaxSetting = async () => {
    try {
      const apiService = new ApiService();
      const res = await apiService.get('GET_TAX_SETTING');
      const taxInclusive = Boolean(res?.data?.result?.taxInclusive);
      syncReduxWithApiValue(taxInclusive);
    } catch (error) {
      console.error('Failed to fetch tax setting:', error);
      toast.error('Failed to load tax setting');
    }
  };

  const syncReduxWithApiValue = (taxInclusive) => {
    if (taxInclusive) {
      dispatch(setTaxImplicit(true));
      dispatch(setTaxExplicit(false));
    } else {
      taxExplicit = taxInclusive || false;
      dispatch(setTaxExplicit(true));
      dispatch(setTaxImplicit(false));
    }
  };

  const [resumedOrderId, setResumedOrderId] = useState(null);
  const [showPrinterSettings, setShowPrinterSettings] = useState(false);
  const currentDate = new Date().toISOString();
  const [isEditingAmount, setIsEditingAmount] = useState(false);
  const [isPlacingOrder, setIsPlacingOrder] = useState(false);
  const [stockMap, setStockMap] = useState({});
  const [stockLoadingMap, setStockLoadingMap] = useState({});
  const [stockErrorMap, setStockErrorMap] = useState({});
  const [showPasscodePopup, setShowPasscodePopup] = useState(false);

  let navigate = useNavigate();
  const location = useLocation();
  const state = location?.state;
  const Update = state?.Update;
  const allowed = state?.allowed;
  const dispatch = useDispatch();

  const isGiftCardMethod = (id) => Number(id) === GIFT_CARD_PAYMENT_METHOD_ID;

  const [dateNow, setDateNow] = useState('');
  const [buttonEnable, setButtonEnable] = useState(state?.state ? true : false);
  const [orderType, setType] = useState(orderTypeR);
  const [PaymentType, setPaymentType] = useState(1);

  const [Customers, setCustomer] = useState([]);
  const [selectedTaxPercentage, setSelectedTaxPercentage] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [taxes, setTax] = useState([]);
  const [totalRate, setTotalRate] = useState(0);

  const isFlocashPayment = PaymentType === 3;
  const isCardPayment = PaymentType === 8;
  const isEftPayment = PaymentType === 9;
  const isAccountPayment = PaymentType === 10;
  const isCashPayment = PaymentType === 1;
  const isGiftCardPayment = PaymentType === GIFT_CARD_PAYMENT_METHOD_ID;

  const [show, setShow] = useState(false);
  const [discountModal, setDiscountModalOpen] = useState(false);
  const [TaxModal, setTaxModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedCartItem, setSelectedCartItem] = useState(null);
  const [isHeldModalOpen, setIsHeldModalOpen] = useState(false);
  const [heldOrders, setHeldOrders] = useState([]);
  const isGiftCardMode = location?.state?.mode === 'GIFT_CARD';
  const isGiftCardLine = !!(selectedCartItem?.isGiftCard || selectedCartItem?.item?.isGiftCard || selectedCartItem?.itemData?.isGiftCard);

  const [formData, setFormData] = useState({
    name: '',
    amountCollected: '',
    due: 0,
    change: 0,
    customerName: '',
    cardApprovalNo: '',
    cardLast4Digits: '',
    eftReference: '',
    accountNumber: '',
  });

  const [areAllButtonsDisabled, setAreAllButtonsDisabled] = useState(false);
  const [areDiscountDisable, setDiscountDisable] = useState(false);
  const [isPaymentAllow, setPaymentAllow] = useState(true);
  const [areTaxDisable, setTaxDisable] = useState(false);

  let token = localStorage.getItem('Token');
  let Permission = userManagement?.getUserCrud(token);
  let role = userManagement?.getUserRole(token);

  const getMaterialNoFromCartItem = (item) =>
    item?.selectedVariant?.itemNo || item?.item?.itemNo || item?.id || item?.item?.recordId || item?.item?.record_Id || '';

  const getCachedStockQty = (item) => {
    const materialNo = getMaterialNoFromCartItem(item);
    if (!materialNo) return null;
    const fromMap = stockMap[materialNo]?.quantityNew;
    if (typeof fromMap === 'number') return fromMap;
    if (item.stockData && typeof item.stockData.quantityNew === 'number') return item.stockData.quantityNew;
    return null;
  };

  const normalizeSerialNumbers = (item) => {
    const raw = item?.serialNumbers ?? item?.item?.serialNumbers ?? item?.itemSerialNumbers ?? item?.item?.itemSerialNumbers ?? [];
    const single = item?.serialNumber ?? item?.item?.serialNumber ?? item?.itemSerialNumber ?? item?.item?.itemSerialNumber ?? null;

    let arr = [];
    const pushValue = (v) => {
      if (v === undefined || v === null) return;
      if (Array.isArray(v)) {
        v.forEach(pushValue);
        return;
      }
      v.toString()
        .split(',')
        .map((x) => x.trim())
        .filter(Boolean)
        .forEach((x) => arr.push(x));
    };

    pushValue(raw);
    pushValue(single);
    arr = [...new Set(arr)];
    return arr;
  };

  const fetchStockForCartItem = async (item) => {
    const materialNo = getMaterialNoFromCartItem(item);
    if (!materialNo) return null;
    if (stockMap[materialNo]) return stockMap[materialNo];

    setStockLoadingMap((prev) => ({ ...prev, [materialNo]: true }));
    setStockErrorMap((prev) => ({ ...prev, [materialNo]: null }));

    try {
      const apiService = new ApiService();
      const requestBody = {
        request: {
          endpointUrl: 'https://tp-apg-testza.multichoice.co.za/stock-processing-confirmation-api',
          templateName: 'MaterialStockByLocationRequest',
          CountryIdentifier: 'zaf',
          Plant: '2402',
          Material: materialNo.toString(),
          token: await localStorage.getItem('Token'),
        },
      };
      const response = await apiService.post('GET_MATERIAL_STOCK', requestBody);
      if (response?.data?.statusCode === 200 || response?.data?.statusCode === 201) {
        const result = response.data.result;
        setStockMap((prev) => ({ ...prev, [materialNo]: result }));
        return result;
      } else {
        setStockErrorMap((prev) => ({ ...prev, [materialNo]: 'Unable to fetch stock information' }));
        return null;
      }
    } catch (error) {
      console.error('Cashier stock check failed:', error);
      setStockErrorMap((prev) => ({ ...prev, [materialNo]: 'Stock check failed' }));
      return null;
    } finally {
      setStockLoadingMap((prev) => ({ ...prev, [materialNo]: false }));
    }
  };

  const isGiftCardProduct = (x) => !!(x?.isGiftCard || x?.item?.isGiftCard || x?.itemData?.isGiftCard);

  // ===================== ORDER / CART CALCS =====================
  const isOrderLevelDiscount = (x) =>
    x?.lineType === 'ORDER_DISCOUNT' ||
    x?.itemData?.lineType === 'ORDER_DISCOUNT' ||
    x?.item?.itemNo === '__ORDER_DISCOUNT__' ||
    Number(x?.item?.recordId) === -999999;

  const isDiscountLine = (x) => !!(x?.isOrderLevelDiscount || x?.itemData?.isOrderLevelDiscount || x?.isGiftCardDiscount || x?.itemData?.isGiftCardDiscount);

  const displayCartItems = (cartData || []).filter((x) => !isOrderLevelDiscount(x));

  // ===================== PAYMENT HELPERS =====================
  const getPaymentStatus = (paymentType, amountCollected, totalAmount) => {
    if (paymentType === 3) return PaymentStatusEnum.Initiated;
    else if (paymentType === 1 || paymentType === 2) {
      if (amountCollected <= 0) return PaymentStatusEnum.Pending;
      else if (amountCollected >= totalAmount) return PaymentStatusEnum.Paid;
      else if (amountCollected > 0) return PaymentStatusEnum.PartiallyPaid;
    }
    return PaymentStatusEnum.Paid;
  };

  useEffect(() => {
    if (buttonEnable && PaymentType !== 3) {
      const totalAmount = calculateTotalPriceWithTaxesAndDiscounts();
      setFormData((prev) => ({
        ...prev,
        amountCollected: totalAmount,
        change: 0,
        due: totalAmount,
      }));
    }
  }, [buttonEnable, PaymentType, cartData, selectedTaxPercentage]);

  useEffect(() => {
    cartData?.forEach((item) => {
      const materialNo = getMaterialNoFromCartItem(item);
      if (materialNo && !stockMap[materialNo] && !stockLoadingMap[materialNo]) {
        fetchStockForCartItem(item);
      }
    });
  }, [cartData]);

  const getOrderStatus = (paymentStatus, isHeldOrder = false) => {
    if (isHeldOrder) return OrderStatusEnum.Holded;
    if (paymentStatus === PaymentStatusEnum.Paid || paymentStatus === PaymentStatusEnum.PartiallyPaid) return OrderStatusEnum.Accepted;
    return OrderStatusEnum.NewOrder;
  };

  const getFlocashPaymentStatus = (tranStatus) => {
    switch (tranStatus) {
      case 'APPROVED':
        return PaymentStatusEnum.Paid;
      case 'DECLINED':
        return PaymentStatusEnum.Failed;
      case 'PENDING':
        return PaymentStatusEnum.Pending;
      case 'PROCESSING':
        return PaymentStatusEnum.Processed;
      case 'INITIATED':
        return PaymentStatusEnum.Initiated;
      case 'CANCELED':
      case 'CANCELLED':
        return PaymentStatusEnum.Canceled;
      default:
        return PaymentStatusEnum.Pending;
    }
  };

  const getOrderTypeEnumValue = (orderType) => {
    switch (orderType) {
      case 'Dine-In':
        return 0;
      case 'Delivery':
        return 2;
      case 'Take-Away':
        return 1;
      case 'Pick-up':
        return 7;
      default:
        return 1;
    }
  };

  // ===================== CALCULATION FUNCTIONS =====================
  const calculateItemPrice = (item) => {
    if (item?.selectedVariant?.salePrice) return parseFloat(item.selectedVariant.salePrice);
    if (item?.item?.salePrice) return parseFloat(item.item.salePrice);
    if (item?.price) return parseFloat(item.price);
    return 0;
  };

  const getItemDiscountPrice = (item) => {
    const discount = item?.discount || item?.itemData?.discount || 0;
    const discountType = item?.discountType || item?.itemData?.discountType;
    if (!discount || discount === 0) return 0;
    const itemPrice = calculateItemPrice(item);
    if (discountType === 'Percentage') return (itemPrice * parseFloat(discount)) / 100;
    else return parseFloat(discount);
  };

  const getLineDiscount = (item) => {
    if (isOrderLevelDiscount(item)) return 0;
    return getItemDiscountPrice(item);
  };

  const pickDiscountValue = (it) => {
    const top = Number(it?.discount);
    if (!Number.isNaN(top) && top > 0) return top;
    const nested = Number(it?.itemData?.discount);
    if (!Number.isNaN(nested) && nested > 0) return nested;
    return 0;
  };

  const pickDiscountType = (it) => it?.discountType || it?.itemData?.discountType || 'Amount';

  const getOrderLevelDiscountValue = (subtotal) => {
    const t = (globalDiscount?.type || '').toLowerCase();
    const v = Number(globalDiscount?.value || 0);
    if (!v) return 0;
    return t === 'percentage' ? (subtotal * v) / 100 : v;
  };

  const calculateItemTax = (item) => {
    if (isOrderLevelDiscount(item)) return 0;
    const itemPrice = calculateItemPrice(item);
    let taxRate = 0;

    if (item?.selectedVariant?.taxRate) taxRate = parseFloat(item.selectedVariant.taxRate);
    else if (item?.item?.taxRate) taxRate = parseFloat(item.item.taxRate);
    else if (item?.selectedVariant?.vat) {
      const v = parseFloat(item.selectedVariant.vat);
      taxRate = v > 1 ? v : v * 100;
    } else if (item?.item?.vat) {
      const v = parseFloat(item.item.vat);
      taxRate = v > 1 ? v : v * 100;
    } else if (taxExplicit && parseFloat(taxExplicit) > 0) {
      taxRate = parseFloat(taxExplicit);
    }

    if (!taxRate || isNaN(taxRate)) return 0;
    return (taxRate / 100) * itemPrice;
  };

  const calculateTotalPrice = () => {
    let totalPrice = 0;
    cartData?.forEach((item) => {
      if (!item?.void && !item?.itemData?.voidItem && !item?.itemData?.refunded) {
        if (isOrderLevelDiscount(item)) return;
        const itemPrice = calculateItemPrice(item);
        totalPrice += itemPrice * item?.quantity;
      }
    });
    return totalPrice;
  };

  const calculateTotalTax = () => {
    let totalTax = 0;
    cartData?.forEach((item) => {
      if (!item?.void && !item?.itemData?.voidItem && !item?.itemData?.refunded) {
        if (isOrderLevelDiscount(item)) return;
        const itemTax = calculateItemTax(item);
        totalTax += itemTax * item?.quantity;
      }
    });

    const additionalTax =
      selectedTaxPercentage?.reduce((total, tax) => {
        const taxAmount = (totalRate * tax.value.taxPercentage) / 100;
        return total + taxAmount;
      }, 0) || 0;

    return totalTax + additionalTax;
  };

  const calculateTotalDiscount = () => {
    let lineDiscountTotal = 0;
    cartData?.forEach((item) => {
      if (!item?.void && !item?.itemData?.voidItem && !item?.itemData?.refunded) {
        lineDiscountTotal += getItemDiscountPrice(item) * (Number(item?.quantity || 1) || 1);
      }
    });
    const subtotal = calculateTotalPrice();
    const orderLevelDiscount = getOrderLevelDiscountValue(subtotal);
    return lineDiscountTotal + orderLevelDiscount;
  };

  const calculateTotalPriceWithTaxesAndDiscounts = () => {
    const subtotal = calculateTotalPrice();
    const totalTax = calculateTotalTax();
    const totalDiscount = calculateTotalDiscount();
    const total = Math.max(0, subtotal + totalTax - totalDiscount);
    return Number(total.toFixed(2));
  };

  const orderTotal = calculateTotalPriceWithTaxesAndDiscounts();

  // ===================== SPLIT PAYMENT =====================
  const [isSplitPayment, setIsSplitPayment] = useState(false);
  const [showSplitModal, setShowSplitModal] = useState(false);
  const [splitPayments, setSplitPayments] = useState([]);

  const getMethodNameById = (id) => paymentMethod?.find((m) => Number(m?.id) === Number(id))?.name || 'Payment';

  const isFlocashMethod = (id) => {
    const n = getMethodNameById(id).toLowerCase();
    return n.includes('flocash') || n.includes('flow cash') || Number(id) === 3;
  };

  const splitMethodOptions = (paymentMethod || [])
    .filter((m) => m?.active === true)
    .filter((m) => !isFlocashMethod(m?.id))
    .map((m) => ({ value: Number(m.id), label: m.name }));

  const isCashMethod = (id) => {
    const n = getMethodNameById(id).toLowerCase();
    return n.includes('cash') || id === 1;
  };
  const isEftMethod = (id) => {
    const n = getMethodNameById(id).toLowerCase();
    return n.includes('eft') || n.includes('transfer') || id === 9;
  };
  const isAccountMethod = (id) => {
    const n = getMethodNameById(id).toLowerCase();
    return n.includes('account') || id === 10;
  };

  const splitHasCash = splitPayments.some((p) => isCashMethod(p.methodId));

  // ===================== GIFT CARD REDEEM AS PAYMENT =====================
  const [giftCardCode, setGiftCardCode] = useState('');
  const [giftCardLookupLoading, setGiftCardLookupLoading] = useState(false);
  const [giftCardData, setGiftCardData] = useState(null);
  const [giftCardRedeemAmount, setGiftCardRedeemAmount] = useState('');
  const [giftCardPayments, setGiftCardPayments] = useState([]);
  const giftCardInputRef = useRef(null);

  const scanTimerRef = useRef(null);
  const lastLookupRef = useRef({ value: '', at: 0 });
  const lookupSeqRef = useRef(0);

  const getGiftCardBalance = (gc) => {
    const n = (v) => (v === undefined || v === null || v === '' ? 0 : Number(v));
    return n(gc?.currentBalance) || n(gc?.initialAmount) || n(gc?.availableBalance) || n(gc?.availableAmount) || n(gc?.remainingAmount) || n(gc?.amount) || 0;
  };

  const giftCardPaidTotal = giftCardPayments.reduce((s, x) => s + (Number(x?.redeemAmount) || 0), 0);

  const splitTotalPaid = splitPayments.reduce((s, p) => s + (Number(p.amount) || 0), 0);
  const dueAfterGiftCards = Math.max(0, Number((orderTotal - giftCardPaidTotal).toFixed(2)));
  const splitDueTotal = dueAfterGiftCards;
  const splitRemaining = Math.max(0, Number((splitDueTotal - splitTotalPaid).toFixed(2)));

  const calculateGiftCardEligibleTotal = () => {
    let subtotal = 0;
    let tax = 0;
    let lineDiscount = 0;

    for (const item of cartData || []) {
      if (item?.void || item?.itemData?.voidItem || item?.itemData?.refunded) continue;
      if (isDiscountLine(item)) continue;
      if (isGiftCardProduct(item)) continue;

      const price = calculateItemPrice(item);
      const qty = Number(item?.quantity || 1) || 1;

      subtotal += price * qty;
      tax += calculateItemTax(item) * qty;
      lineDiscount += getItemDiscountPrice(item) * qty;
    }

    const otherOrderLevelDiscount = (cartData || [])
      .filter((x) => isOrderLevelDiscount(x))
      .reduce((sum, it) => {
        const qty = Number(it?.quantity || 1) || 1;
        return sum + pickDiscountValue(it) * qty;
      }, 0);

    const total = Math.max(0, subtotal + tax - lineDiscount - otherOrderLevelDiscount);
    return total;
  };

  const eligibleTotal = calculateGiftCardEligibleTotal();
  const eligibleRemaining = Math.max(0, Number((eligibleTotal - giftCardPaidTotal).toFixed(2)));

  const buildGiftCardRedemptions = (splitRows = []) => {
    const fromInlineGiftMode = (giftCardPayments || []).map((g) => ({
      rgiftCardCode: String(g.giftCardCode || '').trim(),
      giftCardId: Number(g.giftCardId || 0),
      redeemAmount: Number(g.redeemAmount || 0),
      rdiscountType: 'GiftCard',
      records: Array.isArray(g.records) ? g.records : [],
    }));

    const fromSplitGiftRows = (splitRows || [])
      .filter((r) => Number(r?.methodId) === GIFT_CARD_PAYMENT_METHOD_ID)
      .filter((r) => r?.giftCardData)
      .map((r) => ({
        rgiftCardCode: String(r.giftCardData?.giftCardCode || r.giftCardCode || '').trim(),
        giftCardId: Number(r.giftCardData?.giftCardId || r.giftCardData?.id || 0),
        redeemAmount: Number(r.amount || 0),
        rdiscountType: 'GiftCard',
        records: Array.isArray(r.giftCardData?.records) ? r.giftCardData.records : [],
      }));

    const seen = new Set();
    return [...fromInlineGiftMode, ...fromSplitGiftRows].filter((x) => {
      const code = x.rgiftCardCode;
      if (!code || seen.has(code)) return false;
      seen.add(code);
      return true;
    });
  };

  const resetGiftCardLookup = () => {
    setGiftCardCode('');
    setGiftCardData(null);
    setGiftCardRedeemAmount('');
  };

  const lookupGiftCard = async (input) => {
    const raw = (input || giftCardCode || '').trim();
    if (!raw) {
      toast.warning('Scan / enter gift card first.');
      return;
    }

    const now = Date.now();
    if (lastLookupRef.current.value === raw && now - lastLookupRef.current.at < 800) return;
    lastLookupRef.current = { value: raw, at: now };

    setGiftCardLookupLoading(true);
    setGiftCardData(null);

    const seq = ++lookupSeqRef.current;

    try {
      const apiService = new ApiService();
      const looksLikeGiftCardCode = /^GC[-_]?/i.test(raw);
      const paramName = looksLikeGiftCardCode ? 'giftCardCode' : 'barcode';

      const res = await apiService.getApiParamater('CHECK_GIFT_CARD', `?${paramName}=${encodeURIComponent(raw)}`);

      if (seq !== lookupSeqRef.current) return;

      const gc = res?.data?.result;
      if (!gc) {
        toast.error('Gift card not found.');
        return;
      }

      setGiftCardData(gc);
      const balance = getGiftCardBalance(gc);
      const suggested = Math.max(0, Math.min(balance, eligibleRemaining, dueAfterGiftCards));
      setGiftCardRedeemAmount(suggested.toFixed(2));
    } catch (err) {
      if (seq !== lookupSeqRef.current) return;
      console.error('Gift card lookup failed:', err);
      toast.error(err?.response?.data?.message || 'Gift card lookup failed.');
    } finally {
      if (seq === lookupSeqRef.current) setGiftCardLookupLoading(false);
    }
  };

  const onGiftCardInputChange = (val) => {
    setGiftCardCode(val);
    if (scanTimerRef.current) clearTimeout(scanTimerRef.current);
    const trimmed = (val || '').trim();
    const scanLike = /^\d{6,}$/.test(trimmed) || /^GC-/i.test(trimmed);
    if (!scanLike) return;
    scanTimerRef.current = setTimeout(() => {
      lookupGiftCard(trimmed);
    }, 250);
  };

  const applyGiftCardPayment = () => {
    if (!giftCardData) {
      toast.warning('Lookup gift card first.');
      return;
    }

    const realCode = (giftCardData?.giftCardCode || giftCardCode || '').trim();
    if (!realCode) {
      toast.warning('Gift card code missing from lookup result.');
      return;
    }

    const alreadyUsed = giftCardPayments.some((x) => String(x?.giftCardCode || '').trim() === realCode);
    if (alreadyUsed) {
      toast.warning('This gift card is already applied. Use another card.');
      return;
    }

    const balance = getGiftCardBalance(giftCardData);
    const amount = Number(giftCardRedeemAmount) || 0;
    const maxAllowed = Math.max(0, Math.min(balance, eligibleRemaining, dueAfterGiftCards));

    if (amount <= 0) return toast.warning('Enter amount greater than 0.');
    if (amount > maxAllowed + 0.01) return toast.warning(`Max you can use is ${maxAllowed.toFixed(2)}.`);

    const amountFixed = Number(amount.toFixed(2));

    setGiftCardPayments((prev) => [
      ...prev,
      {
        giftCardCode: realCode,
        giftCardId: Number(giftCardData?.giftCardId || giftCardData?.id || 0),
        redeemAmount: amountFixed,
        records: giftCardData?.records || [],
        balanceAtApply: Number(balance || 0),
      },
    ]);

    toast.success('Gift card applied as payment.');
    resetGiftCardLookup();

    const remaining = Math.max(0, Number((orderTotal - (giftCardPaidTotal + amountFixed)).toFixed(2)));
    if (remaining > 0.01) {
      setIsSplitPayment(true);
      setShowSplitModal(true);
      setSplitPayments((prev) => {
        if (prev && prev.length) return prev;
        return [{ uid: Date.now(), methodId: 1, amount: remaining.toFixed(2), eftReference: '', accountNumber: '' }];
      });
      toast.info(`Please pay remaining ${Currency?.currency?.code} ${remaining.toFixed(2)} using split payment.`);
    }
  };

  const removeGiftCardPayment = (code) => {
    const c = String(code || '').trim();
    if (!c) return;
    setGiftCardPayments((prev) => prev.filter((x) => String(x?.giftCardCode || '').trim() !== c));
    toast.info('Gift card removed.');
  };

  // ===================== Split validation =====================
  const validateSplitPayments = (silent = false) => {
    if (!splitPayments.length) {
      if (!silent) toast.warning('Add at least one payment.');
      return false;
    }

    for (let i = 0; i < splitPayments.length; i++) {
      const row = splitPayments[i];
      const methodId = Number(row?.methodId);
      const amount = Number(row?.amount) || 0;

      if (!methodId) {
        if (!silent) toast.warning(`Select method in row ${i + 1}`);
        return false;
      }
      if (isFlocashMethod(methodId)) {
        if (!silent) toast.warning('Flocash not allowed in split.');
        return false;
      }
      if (amount <= 0) {
        if (!silent) toast.warning(`Enter amount > 0 in row ${i + 1}`);
        return false;
      }

      if (isGiftCardMethod(methodId)) {
        const gc = row?.giftCardData;
        if (!gc) {
          if (!silent) toast.warning(`Lookup gift card in row ${i + 1}`);
          return false;
        }
        const balance = Number(row?.giftBalance) || getGiftCardBalance(gc);
        if (amount > balance + 0.01) {
          if (!silent) toast.warning(`Row ${i + 1}: amount exceeds gift card balance.`);
          return false;
        }
        const otherPaid = splitPayments.reduce((s, p, idx) => (idx === i ? s : s + (Number(p.amount) || 0)), 0);
        const maxForThisRow = Math.max(0, splitDueTotal - otherPaid);
        if (amount > maxForThisRow + 0.01) {
          if (!silent) toast.warning(`Row ${i + 1}: amount exceeds remaining due.`);
          return false;
        }
      }
    }

    const paid = splitPayments.reduce((s, p) => s + (Number(p.amount) || 0), 0);
    const diff = Math.abs(paid - splitDueTotal);
    if (diff <= 0.01) return true;

    if (!silent) toast.warning('Split total must equal due.');
    return false;
  };

  useEffect(() => {
    if (!buttonEnable) return;

    const collected = Number((giftCardPaidTotal + (isSplitPayment ? splitTotalPaid : 0)).toFixed(2));
    const change = isSplitPayment
      ? splitPayments.some((p) => isCashMethod(p.methodId))
        ? Math.max(0, Number((giftCardPaidTotal + splitTotalPaid - orderTotal).toFixed(2)))
        : 0
      : isCashPayment
        ? Math.max(0, Number((Number(formData.amountCollected || 0) - orderTotal).toFixed(2)))
        : 0;

    setFormData((prev) => ({
      ...prev,
      due: orderTotal,
      amountCollected: isSplitPayment ? collected : prev.amountCollected,
      change: isSplitPayment ? change : prev.change,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttonEnable, giftCardPaidTotal, isSplitPayment, splitPayments, splitTotalPaid, orderTotal]);

  useEffect(() => {
    if (!buttonEnable) return;
    if (isSplitPayment && splitPayments.length === 0) {
      setSplitPayments([
        {
          uid: Date.now(),
          methodId: 1,
          amount: Number(dueAfterGiftCards.toFixed(2)),
          eftReference: '',
          accountNumber: '',
        },
      ]);
    }
    if (!isSplitPayment && splitPayments.length) {
      setSplitPayments([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttonEnable, isSplitPayment]);

  useEffect(() => {
    if (buttonEnable && PaymentType !== 3 && PaymentType !== GIFT_CARD_PAYMENT_METHOD_ID && !isSplitPayment) {
      setFormData((prev) => ({
        ...prev,
        amountCollected: orderTotal,
        change: 0,
        due: orderTotal,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttonEnable, PaymentType, cartData, selectedTaxPercentage, isSplitPayment]);

  useEffect(() => {
    if (buttonEnable && PaymentType === GIFT_CARD_PAYMENT_METHOD_ID && !isSplitPayment) {
      setFormData((prev) => ({ ...prev, amountCollected: 0, change: 0, due: orderTotal }));
      setTimeout(() => giftCardInputRef.current?.focus(), 250);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttonEnable, PaymentType, isSplitPayment]);

  // ===================== PAYMENT SUFFICIENCY =====================
  const singleCollected = Number(formData.amountCollected || 0);

  // For non-cash, non-gift, non-flocash methods (card, eft, account) the amount
  // is always the order total — treat them as sufficient when a method is selected.
  const isNonCashDirectMethod = !isFlocashPayment && !isGiftCardPayment && !isCashPayment && PaymentType > 0;

  const isPaymentSufficient = isSplitPayment
    ? validateSplitPayments(true) && giftCardPaidTotal + splitTotalPaid >= orderTotal - 0.01
    : isFlocashPayment ||
      isNonCashDirectMethod || // ✅ card / eft / account always sufficient
      (isGiftCardPayment ? giftCardPaidTotal >= orderTotal - 0.01 : singleCollected >= orderTotal - 0.01);

  const isCardInfoValid = true;
  const isEftInfoValid = !isEftPayment || (formData.eftReference || '').toString().trim().length > 0;
  const isAccountInfoValid = !isAccountPayment || (formData.accountNumber || '').toString().trim().length > 0;

  const isPaymentFormValid = isSplitPayment
    ? validateSplitPayments(true) && giftCardPaidTotal + splitTotalPaid >= orderTotal - 0.01
    : isPaymentSufficient && isCardInfoValid && isEftInfoValid && isAccountInfoValid;

  // ===================== METADATA MAPPING =====================
  const mapDynamicMetaData = (item) => {
    const result = [];

    if (item?.selectedVariant) {
      result.push({
        metaItemId: parseInt(item?.selectedVariant?.recordId || 0),
        type: 4,
        menuItemId: parseInt(item?.item?.recordId || item?.item?.record_Id || 0),
        metaItemIndex: parseInt(item?.index || 0),
        metaItemName: item?.selectedVariant?.itemDescription || '',
        metaItemPrice: parseFloat(item?.selectedVariant?.salePrice || 0),
      });
    }

    if (item?.selectedAdOn && item?.selectedAdOn?.length > 0) {
      item?.selectedAdOn?.forEach((addon) => {
        result.push({
          metaItemId: parseInt(addon?.recordId || 0),
          type: 2,
          menuItemId: parseInt(item?.item?.recordId || item?.item?.record_Id || 0),
          metaItemIndex: parseInt(item?.index || 0),
          metaItemName: addon?.itemName || '',
          metaItemPrice: parseFloat(addon?.salePrice || 0),
        });
      });
    }

    if (item?.selectedModifier && item?.selectedModifier?.length > 0) {
      item?.selectedModifier?.forEach((modifier) => {
        result.push({
          metaItemId: parseInt(modifier?.recordId || 0),
          type: 3,
          menuItemId: parseInt(item?.item?.recordId || item?.item?.record_Id || 0),
          metaItemIndex: parseInt(item?.index || 0),
          metaItemName: modifier?.itemName || '',
          metaItemPrice: parseFloat(modifier?.salePrice || 0),
        });
      });
    }

    return result;
  };

  // ===================== API FUNCTIONS =====================
  const GetMethods = async () => {
    try {
      const apiService = new ApiService();
      let res = await apiService.get('GET_PAYMENT_METHOD');
      const filteredMenu = res.data.result.filter((item) => item?.active === true);
      setPaymentMethod(filteredMenu);
    } catch (error) {
      console.error('Error fetching paymentMethod data:', error);
    }
  };

  const GetCostumer = async () => {
    const apiService = new ApiService();
    try {
      let res = await apiService.get('GET_COSTUMER');
      setCustomer(res?.data?.result);
    } catch (error) {
      console.error('Error fetching customer data:', error);
    }
  };

  const GetTax = async () => {
    const apiService = new ApiService();
    let res = await apiService.get('GET_TAX');
    const filteredTax = res?.data?.result?.filter((tax) => tax?.vat === true);
    setTax(filteredTax);
  };

  const GetOrders = async () => {
    const apiService = new ApiService();
    let param = `?OrderStatus=${OrderStatusEnum.Holded}`;
    let res = await apiService.getApiParamater('GET_ORDERS', param);
    setHeldOrders(res?.data?.result || []);
  };

  const handleOpenCashDrawer = async () => {
    try {
      await ReceiptPrintService.openCashDrawer();
      toast.success('Cash drawer opened');
    } catch (error) {
      console.error('Failed to open cash drawer:', error);
      toast.error('Failed to open cash drawer. Please check printer IP / connection.');
    }
  };

  // ===================== STEP 1: SOAP SALE ORDER =====================
  const createSoapSaleOrder = async () => {
    try {
      const soapRequest = {
        request: {
          endpointUrl: 'https://tp-apg-testza.multichoice.co.za/ws/SalesProcessingConfirmationAPI.HTTP_Port/1.0',
          templateName: 'SalesOrderCreateRequest',
          countryIdentifier: 'zaf',
          plant: '2402',
          salesType: 'L',
          referenceId: `QSS-${Date.now()}`,
          pricingDate: new Date().toISOString().split('T')[0],
          cashier: 'EMS',
          items:
            cartData
              ?.filter((item) => !item?.void && !item?.itemData?.voidItem && !item?.itemData?.refunded)
              ?.map((item) => ({
                material: item?.id || item?.item?.itemNo || `${item?.item?.recordId}`,
                quantity: parseInt(item?.quantity || 1),
              })) || [],
        },
      };

      console.log('STEP 1 — Creating SOAP Sale Order:', soapRequest);

      const apiService = new ApiService();
      const soapResponse = await apiService.post('CREATE_SOAP_SALE_ORDER', soapRequest);

      if (soapResponse?.data?.statusCode === 200 || soapResponse?.data?.isSuccessful) {
        console.log('STEP 1 — SOAP Sale Order created:', soapResponse.data);
        return {
          success: true,
          data: soapResponse.data,
          referenceID: soapResponse.data?.result?.referenceID || soapResponse.data?.referenceID,
          soapSaleOrderId: soapResponse.data?.result?.salesOrderNumber || soapResponse.data?.salesOrderNumber,
        };
      } else {
        console.error('STEP 1 — SOAP Sale Order failed:', soapResponse?.data);
        return {
          success: false,
          error: soapResponse?.data?.message || 'SOAP order creation failed',
        };
      }
    } catch (error) {
      console.error('STEP 1 — SOAP Sale Order API error:', error);
      return {
        success: false,
        error: error?.response?.data?.message || error.message || 'Failed to create SOAP order',
      };
    }
  };

  // ===================== STEP 2: STOCK DECREMENT =====================
  const decrementSoapStock = async (soapSaleOrderId, referenceId) => {
    try {
      const filteredCart = cartData?.filter((item) => !item?.void && !item?.itemData?.voidItem && !item?.itemData?.refunded) || [];

      const stockIssueList = [];

      filteredCart.forEach((item) => {
        const material = item?.id || item?.item?.itemNo || `${item?.item?.recordId}`;
        const qty = parseInt(item?.quantity || 1, 10);
        const rawSerials = item.serialNumbers || item.item?.serialNumbers || [];
        const singleSerial = item.serialNumber || item.item?.serialNumber || null;

        let itemSerials = [];
        if (Array.isArray(rawSerials)) itemSerials = rawSerials;
        else if (rawSerials) itemSerials = [rawSerials];

        if (singleSerial) {
          const trimmedSingle = singleSerial.toString().trim();
          if (trimmedSingle && !itemSerials.includes(trimmedSingle)) itemSerials.push(trimmedSingle);
        }

        itemSerials = itemSerials.map((sn) => (sn || '').toString().trim()).filter((sn) => sn);

        stockIssueList.push({
          material,
          quantity: qty,
          serialNumbers: itemSerials.length ? itemSerials : [],
        });
      });

      const decrementRequest = {
        request: {
          endpointUrl: 'https://tp-apg-testza.multichoice.co.za/ws/StockProcessingConfirmation_InService.HTTP_Port2/1.0',
          token: token,
          templateName: 'GoodsMovementForReferenceIDRequest',
          parameters: {
            CountryIdentifier: 'zaf',
            cashier: 'EMS',
            referenceID: referenceId,
            stockIssueList,
          },
        },
      };

      console.log('STEP 2 — Decrementing SOAP Stock:', JSON.stringify(decrementRequest, null, 2));

      const apiService = new ApiService();
      const response = await apiService.post('UPDATE_SOAP_STOCK', decrementRequest);

      if (response?.data?.statusCode === 200 || response?.data?.isSuccessful) {
        console.log('STEP 2 — Stock decremented successfully:', response.data);
        return { success: true, data: response.data };
      } else {
        console.error('STEP 2 — Stock decrement failed:', response?.data);
        return {
          success: false,
          error: response?.data?.message || 'Stock decrement failed',
        };
      }
    } catch (error) {
      console.error('STEP 2 — Stock decrement API error:', error);
      return {
        success: false,
        error: error?.response?.data?.message || error.message,
      };
    }
  };

  // ===================== STEP 3: CREATE ORDER =====================
  const createOrder = async (totalAmountParam, soapResult, stockResult, splitRows, collected, change) => {
    const currentDateX = new Date().toISOString();
    const totalTax = calculateTotalTax();
    const totalDiscount = calculateTotalDiscount();
    const usingSplit = Array.isArray(splitRows) && splitRows.length > 0;

    const firstCartItemWithDiscount = cartData.find((item) => item?.discountId || item?.itemData?.discountId);
    const firstCartItemWithPromotion = cartData.find((item) => item?.promotionId || item?.itemData?.promotionId);

    const paymentStatus =
      collected >= totalAmountParam - 0.01 ? PaymentStatusEnum.Paid : collected > 0 ? PaymentStatusEnum.PartiallyPaid : PaymentStatusEnum.Pending;

    const orderBody = {
      orderDate: currentDateX,
      orderType: getOrderTypeEnumValue(orderType),
      orderSource: 0,
      orderStatus: 6,
      orderAmount: calculateTotalPrice(),
      calculatedTax: totalTax,
      totalDiscount: totalDiscount,
      amountCollected: collected,
      amountReturned: change,
      customerType: 0,
      customerId: formData?.customerName?.value?.id || 'Guest',
      customerName: formData?.customerName?.label || 'Guest',
      tableId: orderType === 'Dine-In' ? tableData?.[0]?.id || 0 : 0,
      discountId: firstCartItemWithDiscount?.discountId || firstCartItemWithDiscount?.itemData?.discountId || 0,
      promotionId: firstCartItemWithPromotion?.promotionId || firstCartItemWithPromotion?.itemData?.promotionId || 0,
      paymentStatus,
      invoiceNumber: 'INVOICE_' + Date.now(),
      currency: Currency?.currency?.code || 'PKR',
      terminalId: 'string',
      branchId: 0,
      res_Branch_Id: 0,
      soapSaleOrderRefId: soapResult?.referenceID || 'string',
      soapSaleOrderId: soapResult?.soapSaleOrderId || null,
      SaleOrderStatus: 'Success',
      GoodsMovementStatus: stockResult?.success ? 'Success' : 'Failed',
      GoodsMovementRemarks: stockResult?.error || '',
      giftCardRedemptions: buildGiftCardRedemptions(usingSplit ? splitRows : []),
      orderItems: cartData?.map((item, index) => {
        const itemPrice = calculateItemPrice(item);
        const itemDiscount = isOrderLevelDiscount(item) ? 0 : getItemDiscountPrice(item);
        const serialArr = normalizeSerialNumbers(item);
        return {
          itemId: parseInt(item?.item?.recordId || item?.item?.record_Id || 0),
          itemName: item?.name || item?.item?.itemName || 'Item',
          menuItemDiscount: itemDiscount,
          menuItemTax: calculateItemTax(item),
          itemAmount: itemPrice,
          quantity: parseInt(item.quantity || 1),
          kitchenInstructions: item.specialInstructions || '',
          voidItem: item?.void || item?.itemData?.voidItem || false,
          refunded: item?.refund || item?.itemData?.refunded || false,
          taxIncluded: item?.selectedVariant?.vat ? true : false,
          itemIndex: index,
          invoiceId: 0,
          discountId: item?.discountId || item?.itemData?.discountId || 0,
          discountType: item?.discountType || item?.itemData?.discountType || 'Percentage',
          discountValue: item?.discount || item?.itemData?.discount || 0,
          itemSerialNumbers: serialArr.join(','),
          serialNumbersCsv: serialArr,
          itemType: item?.isGiftCard ? false : true,
        };
      }),
      itemSerialNumbers: cartData?.serialNumber,
      cardLast4Digits: isCardPayment ? parseInt(formData.cardLast4Digits) : null,
      cardApprovalNo: isCardPayment ? formData.cardApprovalNo : null,
      eftReference: isEftPayment ? formData.eftReference : null,
      orderItemsMeta: (cartData || []).filter((x) => !isOrderLevelDiscount(x)).flatMap(mapDynamicMetaData),
      orderTax:
        selectedTaxPercentage?.map((tax) => ({
          taxId: tax.value?.id || 0,
          amount: (totalRate * tax.value.taxPercentage) / 100 || 0,
          percentage: tax.value.taxPercentage || 0,
          type: 'Tax',
        })) || [],
      loggedInUserId: userId?.toString() || 'string',
    };

    console.log('STEP 3 — Creating Order:', orderBody);

    const apiService = new ApiService();
    const res = await apiService.post('CREATE_ORDER', orderBody);
    return res;
  };

  // ===================== STEP 4: PAYMENTS =====================
  const createPayment = async (orderId, amount) => {
    try {
      const methodId = Number(PaymentType);
      const method = paymentMethod.find((p) => Number(p.id) === methodId);
      const methodName = method?.name || 'Payment';
      const lower = methodName.toLowerCase();

      console.log('createPayment called — orderId:', orderId, 'amount:', amount, 'PaymentType:', PaymentType, 'methodName:', methodName);

      // ✅ Guard: only skip for flocash (method ID 3), not for card/eft/account
      const isFlocash = methodId === 3;
      if (isFlocash) {
        console.warn('createPayment: skipping flocash, handled separately.');
        return;
      }

      const isCash = lower.includes('cash') || methodId === 1;
      const isEft = lower.includes('eft') || lower.includes('bank transfer') || lower.includes('transfer') || methodId === 9;
      const isCard = lower.includes('card') || methodId === 8;
      const isAcct = lower.includes('account') || methodId === 10;

      // ✅ For cash: use what cashier entered (may be more → gives change)
      // ✅ For card/eft/account: always charge exact order amount
      const orderAmount = Number(amount || 0);
      const tendered = isCash ? Math.max(orderAmount, Number(formData.amountCollected || orderAmount)) : orderAmount;
      const change = isCash ? Math.max(0, Number((tendered - orderAmount).toFixed(2))) : 0;
      const netApplied = Number((tendered - change).toFixed(2));

      const paymentStatus =
        netApplied >= orderAmount - 0.01 ? PaymentStatusEnum.Paid : netApplied > 0 ? PaymentStatusEnum.PartiallyPaid : PaymentStatusEnum.Pending;

      let notes = `Payment via ${methodName}`;
      if (isEft) notes += ` | Ref: ${formData.eftReference || '-'}`;
      if (isCard) notes += ` | Card`;
      if (isAcct) notes += ` | Account: ${formData.accountNumber || '-'}`;

      const paymentBody = {
        orderId,
        paymentMethodId: methodId,
        paymentMethodName: methodName,
        amount: netApplied,
        paymentAmount: netApplied,
        paymentMethod: methodId,
        amountPaid: tendered,
        change,
        paymentStatus,
        transactionId: `TXN_${Date.now()}_${methodId}`,
        paymentDate: new Date().toISOString(),
        currency: Currency?.currency?.code || 'PKR',
        customerId: formData?.customerName?.value?.id || userId?.toString() || 'Guest',
        customerName: formData?.customerName?.label || 'Guest',
        notes,
        paymentType: methodId,
        cardLast4Digits: isCard ? formData.cardLast4Digits || null : null,
        cardApprovalNo: isCard ? formData.cardApprovalNo || null : null,
        eftReference: isEft ? formData.eftReference || null : null,
        accountNumber: isAcct ? formData.accountNumber || null : null,
      };

      console.log('createPayment body:', paymentBody);

      const apiService = new ApiService();
      const res = await apiService.post('CREATE_PAYMENT', paymentBody);

      console.log('createPayment response:', res?.data);

      if (res?.data?.statusCode !== 201) {
        console.warn('Payment API did not return 201:', res?.data);
        toast.warning('Payment record may not have saved correctly.');
      }
    } catch (error) {
      console.error('Payment creation failed:', error);
      toast.error('Payment creation failed: ' + (error?.response?.data?.message || error.message));
    }
  };

  const createPaymentForSplitRow = async (orderId, row, orderTotalParam) => {
    try {
      const methodId = Number(row.methodId);
      const methodName = getMethodNameById(methodId);
      const tenderedRow = Number(row.amount) || 0;

      const paidTenderedTotal = splitPayments.reduce((s, p) => s + (Number(p.amount) || 0), 0) + giftCardPaidTotal;
      const hasCash = splitPayments.some((p) => isCashMethod(p.methodId));
      const totalChange = hasCash ? Math.max(0, Number((paidTenderedTotal - orderTotalParam).toFixed(2))) : 0;

      const cashRowUids = splitPayments.filter((p) => isCashMethod(p.methodId)).map((p) => p.uid);
      const isFirstCashRow = isCashMethod(methodId) && cashRowUids[0] === row.uid;
      const rowChange = isFirstCashRow ? totalChange : 0;
      const netApplied = Math.max(0, Number((tenderedRow - rowChange).toFixed(2)));

      const paymentBody = {
        orderId,
        paymentMethodId: methodId,
        paymentMethodName: methodName,
        amount: netApplied,
        paymentAmount: netApplied,
        paymentMethod: methodId,
        amountPaid: netApplied,
        change: rowChange,
        paymentStatus: PaymentStatusEnum.Paid,
        transactionId: `TXN_${Date.now()}_${methodId}`,
        paymentDate: new Date().toISOString(),
        currency: Currency?.currency?.code || 'PKR',
        customerId: formData?.customerName?.value?.id || userId?.toString() || 'Guest',
        customerName: formData?.customerName?.label || 'Guest',
        notes: `Split payment via ${methodName}`,
        paymentType: methodId,
        eftReference: isEftMethod(methodId) ? row.eftReference || null : null,
        accountNumber: isAccountMethod(methodId) ? row.accountNumber || null : null,
      };

      const apiService = new ApiService();
      await apiService.post('CREATE_PAYMENT', paymentBody);
    } catch (error) {
      console.error('Split payment create failed:', error);
    }
  };

  const createPaymentForGiftCard = async (orderId, gc) => {
    try {
      const amount = Number(gc?.redeemAmount || 0);
      if (amount <= 0) return;

      const apiService = new ApiService();
      const paymentBody = {
        orderId,
        paymentMethodId: GIFT_CARD_PAYMENT_METHOD_ID,
        paymentMethodName: getMethodNameById(GIFT_CARD_PAYMENT_METHOD_ID) || 'Gift Card',
        amount,
        paymentMethod: GIFT_CARD_PAYMENT_METHOD_ID,
        paymentAmount: amount,
        amountPaid: amount,
        change: 0,
        paymentStatus: PaymentStatusEnum.Paid,
        transactionId: `GC_${Date.now()}_${String(gc?.giftCardCode || '').slice(-6)}`,
        paymentDate: new Date().toISOString(),
        currency: Currency?.currency?.code || 'PKR',
        customerId: formData?.customerName?.value?.id || userId?.toString() || 'Guest',
        customerName: formData?.customerName?.label || 'Guest',
        notes: `Gift Card Payment | Code: ${gc?.giftCardCode || '-'}`,
        paymentType: GIFT_CARD_PAYMENT_METHOD_ID,
      };

      const res = await apiService.post('CREATE_PAYMENT', paymentBody);
      if (res?.data?.statusCode !== 201) {
        console.warn('Gift card payment create failed');
      }
    } catch (err) {
      console.error('Gift card payment create failed:', err);
    }
  };

  // ===================== STEP 5: RECEIPT / PRINT =====================
  const printReceiptAndVoucher = async (orderId, totalAmountParam, soapResult, splitRows, collected, apiResult) => {
    try {
      const usingSplit = Array.isArray(splitRows) && splitRows.length > 0;
      const currentDateX = new Date().toISOString();
      const totalTax = calculateTotalTax();
      const totalDiscount = calculateTotalDiscount();
      const hasCash = usingSplit ? splitRows.some((r) => isCashMethod(r.methodId)) : isCashPayment;

      const barcodeToPrint = String(apiResult?.updatedgiftcardGiftCardBarcode || '').trim() || String(apiResult?.newGiftCardBarcode || '').trim() || '';
      const giftCardCodeToPrint = String(apiResult?.updatedGiftCardCode || '').trim() || String(apiResult?.newGiftCardCode || '').trim() || '';

      const receiptItems = (cartData || []).filter((x) => !isOrderLevelDiscount(x));

      const paymentsForReceipt = [];
      for (const gc of giftCardPayments) {
        paymentsForReceipt.push({
          method: 'Gift Card',
          amount: Number(gc?.redeemAmount || 0),
          meta: gc?.giftCardCode || '',
        });
      }
      if (usingSplit) {
        for (const r of splitRows) {
          paymentsForReceipt.push({
            method: getMethodNameById(r.methodId),
            amount: Number(r.amount) || 0,
          });
        }
      } else if (PaymentType && PaymentType !== GIFT_CARD_PAYMENT_METHOD_ID) {
        paymentsForReceipt.push({
          method: paymentMethod.find((p) => p.id === PaymentType)?.name || 'Payment',
          amount: Number(formData.amountCollected || 0),
        });
      }

      const isGCProduct = (x) => !!(x?.isGiftCard || x?.item?.isGiftCard || x?.itemData?.isGiftCard);

      const receiptData = {
        orderId,
        barcodeToPrint,
        giftCardCodeToPrint,
        orderDate: currentDateX,
        orderItems: receiptItems.map((item) => ({
          itemName: item?.name || item?.item?.itemName,
          quantity: item.quantity,
          menuItemPrice: calculateItemPrice(item),
          specialInstructions: item.specialInstructions || '',
          selectedVariant: item?.selectedVariant?.itemDescription || null,
          isGiftCard: isGCProduct(item),
        })),
        subtotal: calculateTotalPrice(),
        tax: totalTax,
        discount: totalDiscount,
        total: totalAmountParam,
        payments: paymentsForReceipt,
        amountPaid: collected,
        paymentMethod: usingSplit || giftCardPayments.length ? 'Mixed' : paymentMethod.find((p) => p.id === PaymentType)?.name || 'Payment',
        change: hasCash ? Math.max(0, collected - totalAmountParam) : 0,
        customerName: formData?.customerName?.label || 'Walk-in Customer',
        orderType,
        tableNumber: tableData?.[0]?.tableName || null,
        invoiceNumber: 'INV-' + orderId,
        soapReferenceId: soapResult?.referenceID,
        soapOrderId: soapResult?.soapSaleOrderId,
      };

      await ReceiptPrintService.printReceipt(receiptData, Currency?.currency);

      // Voucher
      try {
        const shouldPrintVoucher = !!(barcodeToPrint || '').trim();
        if (shouldPrintVoucher) {
          const giftCardSaleValue = receiptData.orderItems
            .filter((x) => x.isGiftCard)
            .reduce((s, x) => s + (Number(x.menuItemPrice) || 0) * (Number(x.quantity) || 0), 0);

          const isRedeemVoucher = giftCardPayments.length > 0 && giftCardSaleValue <= 0.001;

          let voucherData = {
            ...receiptData,
            voucherTitle: isRedeemVoucher ? 'GIFT CARD BALANCE' : 'VOUCHER',
            barcodeToPrint: (barcodeToPrint || '').trim(),
            giftCardCodeToPrint: (giftCardCodeToPrint || '').trim(),
          };

          if (isRedeemVoucher) {
            const lastGc = giftCardPayments[giftCardPayments.length - 1];
            const prevBal = Number(lastGc?.balanceAtApply || 0);
            const redeemed = Number(lastGc?.redeemAmount || 0);
            const remaining = Math.max(0, Number((prevBal - redeemed).toFixed(2)));
            voucherData = {
              ...voucherData,
              voucherMode: 'REDEEM',
              voucherPreviousBalance: prevBal,
              voucherRedeemedValue: redeemed,
              voucherRemainingValue: remaining,
              giftCardCodeToPrint: lastGc?.giftCardCode || voucherData.giftCardCodeToPrint,
            };
          } else {
            voucherData = {
              ...voucherData,
              voucherMode: 'SALE',
              voucherValue: Number(giftCardSaleValue || 0),
            };
          }

          await ReceiptPrintService.printVoucher(voucherData, Currency?.currency);
        }
      } catch (e) {
        console.error('Voucher print failed:', e);
        toast.warning('Receipt printed, but voucher print failed.');
      }

      // Cash drawer
      const cashUsed = usingSplit ? splitRows.some((r) => isCashMethod(r.methodId)) : isCashPayment;
      if (cashUsed) await handleOpenCashDrawer();
    } catch (printError) {
      console.error('Printing / drawer failed:', printError);
      toast.warning('Order created but printing / drawer opening failed. You can reprint from order history.');
    }
  };

  // ===================== MAIN ORDER FLOW =====================
  // Strict sequence: SOAP → Stock → Create Order → Payments → Receipt
  const createNewOrderWithPayment = async (totalAmountParam, splitRows = null, { skipPrint = false } = {}) => {
    try {
      const usingSplit = Array.isArray(splitRows) && splitRows.length > 0;

      const splitPaid = usingSplit ? splitRows.reduce((s, r) => s + (Number(r.amount) || 0), 0) : 0;

      const tendered = Number((giftCardPaidTotal + (usingSplit ? splitPaid : Number(formData?.amountCollected || 0))).toFixed(2));

      const hasCash = usingSplit ? splitRows.some((r) => isCashMethod(r.methodId)) : isCashPayment;

      const change = hasCash ? Math.max(0, Number((tendered - totalAmountParam).toFixed(2))) : 0;

      const netCollected = Number((tendered - change).toFixed(2));

      // ─────────────────────────────────────────────
      // STEP 1: SOAP Sale Order
      // ─────────────────────────────────────────────
      console.log('=== STEP 1: Creating SOAP Sale Order ===');
      const soapResult = await createSoapSaleOrder();

      if (!soapResult.success) {
        toast.error(`SOAP API failed: ${soapResult.error}`);
        return;
      }
      toast.success('SOAP order created successfully');
      console.log('STEP 1 complete. referenceID:', soapResult.referenceID);

      // ─────────────────────────────────────────────
      // STEP 2: Stock Decrement
      // ─────────────────────────────────────────────
      let stockResult = { success: false, error: 'Not attempted' };

      if (soapResult.soapSaleOrderId && soapResult.referenceID) {
        console.log('=== STEP 2: Decrementing Stock ===');
        stockResult = await decrementSoapStock(soapResult.soapSaleOrderId, soapResult.referenceID);

        if (!stockResult.success) {
          console.warn('STEP 2 — Stock decrement failed:', stockResult.error);
          toast.warning('Stock update failed. Order will still be created. Please update manually.');
        } else {
          console.log('STEP 2 complete. Stock decremented.');
        }
      } else {
        console.warn('STEP 2 skipped — missing soapSaleOrderId or referenceID.');
      }

      // ─────────────────────────────────────────────
      // STEP 3: Create Order
      // ─────────────────────────────────────────────
      console.log('=== STEP 3: Creating Order ===');
      const res = await createOrder(totalAmountParam, soapResult, stockResult, splitRows, netCollected, change);

      if (res?.data?.statusCode !== 201) {
        toast.warning('Order creation failed. Please try again!');
        return;
      }

      const orderId = res?.data?.result?.id;
      const apiResult = res?.data?.result || {};
      console.log('STEP 3 complete. orderId:', orderId);
      toast.success('Order created successfully');

      // Refresh menu after order creation
      if (typeof menu === 'function') menu();

      // ─────────────────────────────────────────────
      // STEP 4: Payments
      // ─────────────────────────────────────────────
      console.log('=== STEP 4: Creating Payments ===');

      // 4a. Gift card payment records
      if (giftCardPayments.length) {
        for (const gc of giftCardPayments) {
          await createPaymentForGiftCard(orderId, gc);
        }
        console.log(`STEP 4a — ${giftCardPayments.length} gift card payment(s) created.`);
      }

      // 4b. Split or single payments (excluding flocash)
      if (!isFlocashPayment) {
        if (usingSplit) {
          for (const row of splitRows) {
            await createPaymentForSplitRow(orderId, row, totalAmountParam);
          }
          console.log(`STEP 4b — ${splitRows.length} split payment(s) created.`);
        } else if (PaymentType && PaymentType !== GIFT_CARD_PAYMENT_METHOD_ID) {
          await createPayment(orderId, totalAmountParam);
          console.log('STEP 4b — Single payment created.');
        }
      }

      // ─────────────────────────────────────────────
      // STEP 5: Receipt / Print (optional)
      // ─────────────────────────────────────────────
      if (!skipPrint) {
        console.log('=== STEP 5: Printing Receipt ===');
        await printReceiptAndVoucher(orderId, totalAmountParam, soapResult, splitRows, netCollected, apiResult);
        console.log('STEP 5 complete.');
      } else {
        console.log('STEP 5 skipped (skipPrint=true).');
        // Still open cash drawer if cash was used
        const cashUsed = usingSplit ? splitRows.some((r) => isCashMethod(r.methodId)) : isCashPayment;
        if (cashUsed) await handleOpenCashDrawer();
      }

      // ─────────────────────────────────────────────
      // Post-order cleanup
      // ─────────────────────────────────────────────
      toast.success('Order Created Successfully');
      handleUpdateTable();
      handlePromotion();
      invokeBroadCastMessage('New Order Received.');
      handleEnable();

      dispatch(setOrderType(''));
      dispatch(clearCart());
      dispatch(clearTable());
      setType('');
      setFormData({ customerName: '', amountCollected: 0, change: 0, due: 0 });
      setSelectedTaxPercentage([]);

      setIsSplitPayment(false);
      setSplitPayments([]);
      setShowSplitModal(false);
      setGiftCardPayments([]);
      resetGiftCardLookup();
    } catch (error) {
      console.error('Order creation failed:', error);
      toast.error('Failed to create order.');
    }
  };

  const placeOrderWithFlocash = async (paymentResult) => {
    let soapResult = null;

    try {
      if (cartData?.length === 0) {
        toast.warning('Please choose at least a single item to order!');
        return;
      }

      console.log('=== FLOCASH STEP 1: Creating SOAP Sale Order ===');
      soapResult = await createSoapSaleOrder();

      if (!soapResult.success) {
        toast.error(`SOAP API failed: ${soapResult.error}`);
        return;
      }
      toast.success('SOAP order created successfully');

      const currentDateX = new Date().toISOString();
      const totalTax = calculateTotalTax();
      const totalDiscount = calculateTotalDiscount();
      const totalAmount = calculateTotalPriceWithTaxesAndDiscounts();

      const firstCartItemWithDiscount = cartData.find((item) => item?.discountId || item?.itemData?.discountId);
      const firstCartItemWithPromotion = cartData.find((item) => item?.promotionId || item?.itemData?.promotionId);

      const paymentStatus = getFlocashPaymentStatus(paymentResult.tranStatus);
      const orderStatus = paymentResult.tranStatus === 'APPROVED' ? OrderStatusEnum.Accepted : OrderStatusEnum.NewOrder;

      const orderBody = {
        orderDate: currentDateX,
        orderType: getOrderTypeEnumValue(orderType),
        orderSource: 0,
        orderStatus,
        orderAmount: totalAmount,
        calculatedTax: totalTax,
        TotalDiscount: totalDiscount,
        amountCollected: paymentResult.requestAmount || totalAmount,
        amountReturned: 0,
        customerType: 0,
        surfOrderId: soapResult.referenceID || paymentResult.tranId || 'string',
        soapSaleOrderId: soapResult.soapSaleOrderId || null,
        customerId: formData?.customerName?.value?.id || userId?.toString() || 'Guest',
        customerName: formData?.customerName?.label || 'Guest',
        tableId: orderType === 'Dine-In' ? tableData?.[0]?.id || 0 : 0,
        discountId: firstCartItemWithDiscount?.discountId || firstCartItemWithDiscount?.itemData?.discountId || 0,
        promotionId: firstCartItemWithPromotion?.promotionId || firstCartItemWithPromotion?.itemData?.promotionId || 0,
        paymentStatus,
        invoiceNumber: 'INVOICE_' + Date.now(),
        currency: Currency?.currency?.code || 'PKR',
        terminalId: paymentResult.posId || 'string',
        branchId: 0,
        res_Branch_Id: 0,
        soapSaleOrderRefId: soapResult.referenceID || paymentResult.tranId || 'string',
        orderItems: cartData?.map((item, index) => {
          const itemPrice = calculateItemPrice(item);
          const itemDiscount = getItemDiscountPrice(item);
          const serialArr = normalizeSerialNumbers(item);
          return {
            itemId: parseInt(item?.item?.recordId || item?.item?.record_Id || 0),
            itemName: item?.name || item?.item?.itemName || 'Item',
            menuItemName: item?.name || item?.item?.itemName || 'Item',
            menuItemPrice: itemPrice,
            menuItemDiscount: itemDiscount,
            menuItemTax: calculateItemTax(item),
            itemAmount: itemPrice,
            quantity: parseInt(item.quantity || 1),
            kitchenInstructions: item.specialInstructions || '',
            voidItem: item?.void || item?.itemData?.voidItem || false,
            refunded: item?.refund || item?.itemData?.refunded || false,
            taxIncluded: item?.selectedVariant?.vat ? true : false,
            itemIndex: index,
            invoiceId: 0,
            discountId: item?.discountId || item?.itemData?.discountId || 0,
            discountType: item?.discountType || item?.itemData?.discountType || 'Percentage',
            discountValue: item?.discount || item?.itemData?.discount || 0,
            serialNumbers: serialArr,
            itemSerialNumbers: serialArr.join(','),
          };
        }),
        orderItemsMeta: cartData?.flatMap(mapDynamicMetaData),
        orderTax:
          selectedTaxPercentage?.map((tax) => ({
            taxId: tax.value?.id || 0,
            amount: (totalRate * tax.value.taxPercentage) / 100 || 0,
            percentage: tax.value.taxPercentage || 0,
            type: 'Tax',
          })) || [],
        loggedInUserId: userId?.toString() || 'string',
      };

      const apiService = new ApiService();
      const res = await apiService.post('CREATE_ORDER', orderBody);

      if (res?.data?.statusCode === 201) {
        const orderId = res?.data?.result?.id;
        await createFlocashPayment(orderId, totalAmount, paymentResult);

        toast.success('Order Created Successfully with Flocash Payment');
        handleUpdateTable();
        handlePromotion();
        handleEnable();
        invokeBroadCastMessage('New Order Received.');

        dispatch(setOrderType(''));
        dispatch(clearCart());
        dispatch(clearTable());
        setType('');
        setFormData({ customerName: '', amountCollected: 0, change: 0 });
        setSelectedTaxPercentage([]);
        setPaymentType(paymentMethod);
      } else {
        toast.warning('Something went wrong. Please try again!');
      }
    } catch (error) {
      console.error('Flocash order creation failed:', error);
      toast.error('Failed to place order. See console for details.');
    }
  };

  const createFlocashPayment = async (orderId, amount, paymentResult) => {
    try {
      const paymentStatus = getFlocashPaymentStatus(paymentResult.tranStatus);
      const paymentBody = {
        orderId,
        paymentMethodId: 3,
        paymentMethodName: paymentMethod.find((p) => p.id === 3)?.name || 'Flocash',
        amount,
        paymentAmount: amount,
        amountPaid: paymentResult.requestAmount || amount,
        change: 0,
        paymentStatus,
        transactionId: paymentResult.tranId || paymentResult.messageId || `FLOCASH_${Date.now()}`,
        paymentDate: new Date().toISOString(),
        currency: Currency?.currency?.code || 'PKR',
        customerId: formData?.customerName?.value?.id || userId?.toString() || 'Guest',
        customerName: formData?.customerName?.label || 'Guest',
        notes: `Flocash Payment - Message ID: ${paymentResult.messageId}, Status: ${paymentResult.tranStatus}`,
        paymentType: 3,
        flocashData: {
          messageId: paymentResult.messageId,
          posId: paymentResult.posId,
          tranType: paymentResult.tranType,
          tranStatus: paymentResult.tranStatus,
          tranId: paymentResult.tranId,
          currency: paymentResult.currency,
          requestAmount: paymentResult.requestAmount,
          approvalCode: paymentResult.approvalCode,
          responseCode: paymentResult.responseCode,
          responseMessage: paymentResult.responseMessage,
        },
        accountNumber: isAccountPayment ? formData.accountNumber : null,
      };

      const apiService = new ApiService();
      const paymentRes = await apiService.post('CREATE_PAYMENT', paymentBody);

      if (paymentRes?.data?.statusCode === 201) {
        try {
          const printerConfig = JSON.parse(localStorage.getItem('printerConfig') || '{}');
          if (printerConfig.enableAutoprint !== false) {
            const receiptData = {
              orderId,
              orderDate: currentDate,
              orderItems: cartData.map((item) => ({
                itemName: item?.name || item?.item?.itemName,
                quantity: item.quantity,
                menuItemPrice: calculateItemPrice(item),
                specialInstructions: item.specialInstructions || '',
                selectedVariant: item?.selectedVariant?.itemDescription || null,
              })),
              subtotal: calculateTotalPrice(),
              tax: calculateTotalTax(),
              totalDiscount: calculateTotalDiscount(),
              total: calculateTotalPriceWithTaxesAndDiscounts(),
              amountPaid: paymentResult.requestAmount || calculateTotalPriceWithTaxesAndDiscounts(),
              change: 0,
              customerName: formData?.customerName?.label || 'Walk-in Customer',
              orderType,
              tableNumber: tableData?.[0]?.tableName || null,
              invoiceNumber: 'INV-' + orderId,
              paymentMethod: 'Flocash',
            };
            await ReceiptPrintService.printReceipt(receiptData, Currency?.currency);
          }
        } catch (printError) {
          console.error('Printing failed:', printError);
        }
        console.log('Flocash payment record created successfully');
      } else {
        console.warn('Flocash payment record creation failed, but order was created');
      }
    } catch (error) {
      console.error('Flocash payment record creation failed:', error);
    }
  };

  const handleHoldPayment = async () => {
    try {
      if (!cartData || cartData.length === 0) {
        toast.warning('Please add item to process!');
        return;
      }

      const currentDateX = new Date().toISOString();
      const totalAmount = calculateTotalPriceWithTaxesAndDiscounts();
      const totalTax = calculateTotalTax();
      const totalDiscount = calculateTotalDiscount();

      const firstCartItemWithDiscount = cartData.find((item) => item?.discountId || item?.itemData?.discountId);
      const firstCartItemWithPromotion = cartData.find((item) => item?.promotionId || item?.itemData?.promotionId);

      const orderBody = {
        orderDate: currentDateX,
        orderType: getOrderTypeEnumValue(orderType),
        orderSource: 0,
        orderStatus: OrderStatusEnum.Holded,
        orderAmount: totalAmount,
        calculatedTax: totalTax,
        totalDiscount: totalDiscount,
        amountCollected: 0,
        amountReturned: 0,
        customerType: 0,
        customerId: formData?.customerName?.value?.id || userId?.toString() || 'Guest',
        customerName: formData?.customerName?.label || 'Guest',
        tableId: orderType === 'Dine-In' ? tableData?.[0]?.id || 0 : 0,
        discountId: firstCartItemWithDiscount?.discountId || firstCartItemWithDiscount?.itemData?.discountId || 0,
        promotionId: firstCartItemWithPromotion?.promotionId || firstCartItemWithPromotion?.itemData?.promotionId || 0,
        paymentStatus: PaymentStatusEnum.Pending,
        invoiceNumber: 'INVOICE_' + Date.now(),
        currency: Currency?.currency?.code || 'PKR',
        terminalId: 'string',
        branchId: 0,
        res_Branch_Id: 0,
        surfOrderId: 'string',
        orderItems: cartData?.map((item, index) => {
          const serialArr = normalizeSerialNumbers(item);
          return {
            itemId: parseInt(item?.item?.recordId || item?.item?.record_Id || 0),
            itemName: item?.name || item?.item?.itemName || 'Item',
            menuItemName: item?.name || item?.item?.itemName || 'Item',
            menuItemPrice: calculateItemPrice(item),
            menuItemDiscount: getItemDiscountPrice(item),
            menuItemTax: calculateItemTax(item),
            itemAmount: calculateItemPrice(item),
            quantity: parseInt(item.quantity || 1),
            serialNumbers: serialArr,
            itemSerialNumbers: serialArr.join(','),
            kitchenInstructions: item.specialInstructions || '',
            voidItem: false,
            refunded: false,
            taxIncluded: item?.selectedVariant?.vat ? true : false,
            itemIndex: index,
            invoiceId: 0,
            discountId: item?.discountId || item?.itemData?.discountId || 0,
            discountType: item?.discountType || item?.itemData?.discountType || 'Percentage',
            discountValue: item?.discount || item?.itemData?.discount || 0,
          };
        }),
        orderItemsMeta: cartData?.flatMap(mapDynamicMetaData),
        orderTax:
          selectedTaxPercentage?.map((tax) => ({
            taxId: tax.value?.id || 0,
            amount: (totalRate * tax.value.taxPercentage) / 100 || 0,
            percentage: tax.value.taxPercentage || 0,
            type: 'Tax',
          })) || [],
        loggedInUserId: userId?.toString() || 'string',
      };

      const apiService = new ApiService();
      const res = await apiService.post('CREATE_ORDER', orderBody);

      if (res?.data?.statusCode === 201) {
        toast.success('Order is on hold now');
        dispatch(setOrderType(''));
        dispatch(clearCart());
        dispatch(clearTable());
        setType('');
        setSelectedTaxPercentage([]);
        setFormData({ customerName: '', amountCollected: 0, change: 0 });
        GetOrders();
      } else {
        toast.warning('Something went wrong. Please try again!');
      }
    } catch (error) {
      console.error('Error while holding order:', error);
      toast.error('Failed to hold order. Please try again.');
    }
  };

  const processPaymentForExistingOrder = async (orderId, totalAmount) => {
    try {
      if (PaymentType && formData.amountCollected > 0) {
        if (!isFlocashPayment && formData.amountCollected > 0) {
          await createPayment(orderId, totalAmount);
        }
        await updateOrderPaymentStatus(orderId, totalAmount);
        toast.success('Payment Processed Successfully');
        invokeBroadCastMessage(`Payment completed for Order #ORD-${orderId}`);
        handleEnable();
        dispatch(setOrderType(''));
        dispatch(clearCart());
        dispatch(clearTable());
        setType('');
        setFormData({ customerName: '', amountCollected: 0, change: 0 });
        setSelectedTaxPercentage([]);
      } else {
        toast.warning('Please select payment method and enter amount');
      }
    } catch (error) {
      console.error('Payment processing failed:', error);
      toast.error('Failed to process payment');
    }
  };

  const updateOrderPaymentStatus = async (orderId, totalAmount) => {
    try {
      const paymentStatus = formData.amountCollected >= totalAmount ? PaymentStatusEnum.Paid : PaymentStatusEnum.PartiallyPaid;

      const paymentStatusUpdate = {
        id: orderId,
        paymentStatus,
        amountCollected: formData.amountCollected,
        amountReturned: formData.change || 0,
      };

      const apiService = new ApiService();
      await apiService.put('UPDATE_ORDER', paymentStatusUpdate);
      console.log('Order payment status updated successfully');
    } catch (error) {
      console.error('Failed to update order payment status:', error);
    }
  };

  // ===================== PLACE ORDER =====================
  const placeOrder = async () => {
    if (isPlacingOrder) return;
    try {
      setIsPlacingOrder(true);

      if (cartData?.length === 0) {
        toast.warning('Please choose at least a single item to order!');
        return;
      }

      const totalAmountParam = calculateTotalPriceWithTaxesAndDiscounts();

      if (isSplitPayment && PaymentType === 3) {
        toast.warning('Split payment is not allowed with Flocash.');
        return;
      }

      if (PaymentType === GIFT_CARD_PAYMENT_METHOD_ID) {
        if (giftCardPaidTotal <= 0) {
          toast.warning('Please redeem at least one gift card.');
          return;
        }
        if (dueAfterGiftCards > 0.01 && !isSplitPayment) {
          toast.warning('Please pay remaining amount using split payment.');
          setIsSplitPayment(true);
          setShowSplitModal(true);
          return;
        }
      }

      if (resumedOrderId) {
        await updateHeldOrderWithPayment(resumedOrderId, totalAmountParam);
      } else if (Update && state?.originalOrderData) {
        toast.warning('Existing order payment handler not included in this shortened section.');
        return;
      } else {
        if (isSplitPayment) {
          if (!validateSplitPayments(false)) return;
          await createNewOrderWithPayment(totalAmountParam, splitPayments);
        } else {
          await createNewOrderWithPayment(totalAmountParam);
        }
      }
    } catch (error) {
      console.error('Payment processing failed:', error);
      toast.error('Failed to process payment. See console for details.');
    } finally {
      setIsPlacingOrder(false);
    }
  };

  const placeOrderNoPrint = async () => {
    if (isPlacingOrder) return;
    try {
      setIsPlacingOrder(true);

      if (cartData?.length === 0) {
        toast.warning('Please choose at least a single item to order!');
        return;
      }

      const totalAmountParam = calculateTotalPriceWithTaxesAndDiscounts();

      if (isSplitPayment && PaymentType === 3) {
        toast.warning('Split payment is not allowed with Flocash.');
        return;
      }

      if (PaymentType === GIFT_CARD_PAYMENT_METHOD_ID) {
        if (giftCardPaidTotal <= 0) {
          toast.warning('Please redeem at least one gift card.');
          return;
        }
        if (dueAfterGiftCards > 0.01 && !isSplitPayment) {
          toast.warning('Please pay remaining amount using split payment.');
          setIsSplitPayment(true);
          setShowSplitModal(true);
          return;
        }
      }

      if (resumedOrderId) {
        toast.warning('Resumed order handler: use your existing one and pass skipPrint=true.');
        return;
      } else if (Update && state?.originalOrderData) {
        toast.warning('Update order handler: use your existing one and pass skipPrint=true.');
        return;
      } else {
        if (isSplitPayment) {
          if (!validateSplitPayments(false)) return;
          await createNewOrderWithPayment(totalAmountParam, splitPayments, {
            skipPrint: true,
          });
        } else {
          await createNewOrderWithPayment(totalAmountParam, null, {
            skipPrint: true,
          });
        }
      }

      toast.success('Order Created Successfully (No Print)');
    } catch (error) {
      console.error('Payment processing failed:', error);
      toast.error('Failed to process payment. See console for details.');
    } finally {
      setIsPlacingOrder(false);
    }
  };

  // ===================== UTILITY FUNCTIONS =====================
  const handlePromotion = async () => {
    try {
      const itemWithData = cartData.find((item) => item.selectedPromotionDetails || item.itemData?.selectedPromotionDetails);
      if (itemWithData) {
        const selectedPromotionDetails = itemWithData.selectedPromotionDetails || itemWithData.itemData?.selectedPromotionDetails;

        const datareq = {
          id: selectedPromotionDetails?.promotionDetialsId,
          promotionID: selectedPromotionDetails?.promotionID,
          vouchorNo: selectedPromotionDetails?.vouchorNo,
          fromDate: selectedPromotionDetails?.fromDate,
          toDate: selectedPromotionDetails?.toDate,
          status: selectedPromotionDetails?.status,
          useCount: selectedPromotionDetails?.useCount + 1,
        };
        const apiService = new ApiService();
        await apiService.put('UPDATE_PROMOTION_DETAIL', datareq);
      }
    } catch (error) {
      console.error('Error updating promotion:', error);
    }
  };

  const handleUpdateTable = async () => {
    try {
      if (orderType === 'Dine-In' && tableData?.[0]?.id) {
        const datareq = {
          id: tableData[0].id,
          seatCapacity: tableData[0].selectedChairs,
          status: 2,
        };
        const apiService = new ApiService();
        await apiService.put('UPDATE_TABLE', datareq);
      }
    } catch (error) {
      console.error('Error updating table:', error);
    }
  };

  const handleHeldOrder = (heldOrder) => {
    dispatch(clearCart());
    dispatch(clearTable());
    setResumedOrderId(heldOrder.id);

    const orderItems = heldOrder.orderItems || [];
    const orderItemsMeta = heldOrder.orderItemsMeta || [];

    const orderItemsMetaMap = {};
    orderItemsMeta?.forEach((orderItemMeta) => {
      const menuItemId = orderItemMeta.menuItemId;
      if (!orderItemsMetaMap[menuItemId]) orderItemsMetaMap[menuItemId] = [];
      orderItemsMetaMap[menuItemId].push(orderItemMeta);
    });

    orderItems?.forEach((orderItem, index) => {
      const menuItemId = orderItem.itemId;
      const itemMeta = orderItemsMetaMap[menuItemId] || [];
      const selectedVariant = itemMeta.find((meta) => meta.type === 4) || null;
      const selectedAdOn = itemMeta.filter((meta) => meta.type === 2) || [];
      const selectedModifier = itemMeta.filter((meta) => meta.type === 3) || [];

      const processedItem = {
        itemData: {
          ...orderItem,
          id: orderItem.itemId,
          itemId: orderItem.itemId,
          menuItemName: orderItem.menuItemName || orderItem.itemName || `Item ${orderItem.itemId}`,
          menuItemPrice: orderItem.menuItemPrice,
          orderItemsMeta: itemMeta,
          itemIndex: orderItem.itemIndex || index,
          voidItem: orderItem.voidItem || false,
          refunded: orderItem.refunded || false,
          discountId: orderItem.discountId || 0,
          discountType: orderItem.discountType || 'Percentage',
          discount: orderItem.discountValue || 0,
          promotionId: heldOrder.promotionId || 0,
        },
        quantity: orderItem.quantity || 1,
        specialInstructions: orderItem.kitchenInstructions || '',
        selectedVariant: selectedVariant
          ? {
              recordId: selectedVariant.metaItemId,
              itemDescription: selectedVariant.metaItemName,
              salePrice: selectedVariant.metaItemPrice,
            }
          : null,
        selectedAdOn: selectedAdOn.map((addon) => ({
          recordId: addon.metaItemId,
          itemName: addon.metaItemName,
          salePrice: addon.metaItemPrice,
        })),
        selectedModifier: selectedModifier.map((modifier) => ({
          recordId: modifier.metaItemId,
          itemName: modifier.metaItemName,
          salePrice: modifier.metaItemPrice,
        })),
        void: orderItem.voidItem || false,
        refund: orderItem.refunded || false,
        index,
        item: {
          recordId: orderItem.itemId,
          record_Id: orderItem.itemId,
          itemName: orderItem.itemName || orderItem.menuItemName,
          salePrice: orderItem.menuItemPrice,
          itemNo: orderItem.itemId,
        },
        name: orderItem.itemName || orderItem.menuItemName,
        price: orderItem.menuItemPrice,
        discountId: orderItem.discountId || 0,
        discountType: orderItem.discountType || 'Percentage',
        discount: orderItem.discountValue || 0,
        promotionId: heldOrder.promotionId || 0,
      };

      dispatch(AddToCart(processedItem));
    });

    if (heldOrder.orderType !== undefined) {
      const orderTypeMap = { 0: 'Dine-In', 1: 'Take-Away', 2: 'Delivery', 7: 'Pick-up' };
      const orderTypeName = orderTypeMap[heldOrder.orderType] || 'Take-Away';
      dispatch(setOrderType(orderTypeName));
      setType(orderTypeName);
    }

    if (heldOrder.customerName && heldOrder.customerId) {
      const customerOption = {
        value: { id: heldOrder.customerId },
        label: heldOrder.customerName,
      };
      setFormData((prev) => ({ ...prev, customerName: customerOption }));
    }

    if (heldOrder.orderTax && heldOrder.orderTax.length > 0) {
      const taxOptions = heldOrder.orderTax.map((tax) => ({
        value: {
          id: tax.taxId,
          taxPercentage: tax.percentage,
          name: `Tax ${tax.percentage}%`,
        },
        label: `Tax ${tax.percentage}%`,
      }));
      setSelectedTaxPercentage(taxOptions);
    }

    setIsHeldModalOpen(false);
    toast.success('Held order loaded successfully');
  };

  const updateHeldOrderWithPayment = async (orderId, totalAmount) => {
    try {
      const totalTax = calculateTotalTax();
      const totalDiscount = calculateTotalDiscount();
      const paymentStatus = getPaymentStatus(PaymentType, formData.amountCollected, totalAmount);
      const orderStatus = getOrderStatus(paymentStatus);

      const updateOrderBody = {
        id: orderId,
        orderStatus,
        orderAmount: totalAmount,
        calculatedTax: totalTax,
        totalDiscount,
        amountCollected: formData?.amountCollected || 0,
        amountReturned: formData?.change || 0,
        paymentStatus,
        customerId: formData?.customerName?.value?.id || userId?.toString() || 'Guest',
        customerName: formData?.customerName?.label || 'Guest',
      };

      const apiService = new ApiService();
      const res = await apiService.put('UPDATE_ORDER', updateOrderBody);

      if (res?.data?.statusCode === 200 || res?.data?.statusCode === 204) {
        if (!isFlocashPayment && formData.amountCollected > 0) {
          await createPayment(orderId, totalAmount);
        }
        toast.success('Order Updated and Payment Processed Successfully');
        handleUpdateTable();
        handlePromotion();
        invokeBroadCastMessage(`Held order #${orderId} completed with payment.`);
        handleEnable();
        dispatch(setOrderType(''));
        dispatch(clearCart());
        dispatch(clearTable());
        setType('');
        setFormData({ customerName: '', amountCollected: 0, change: 0 });
        setSelectedTaxPercentage([]);
        setResumedOrderId(null);
        GetOrders();
      } else {
        toast.warning('Something went wrong while updating the order. Please try again!');
      }
    } catch (error) {
      console.error('Held order update failed:', error);
      toast.error('Failed to update held order.');
    }
  };

  // ===================== STOCK-AWARE EVENT HANDLERS =====================
  const handleDelete = (itemNo, index) => {
    onRowSelect(null);
    dispatch(RemoveFromCart(itemNo, index));
  };

  const handleQuantityChange = async (item, index) => {
    const materialNo = getMaterialNoFromCartItem(item);
    if (!materialNo) {
      toast.error('Unable to identify item for stock check');
      return;
    }

    let stockQty = getCachedStockQty(item);
    if (stockQty === null || stockQty === undefined) {
      toast.info('Checking stock, please wait...');
      const stockInfo = await fetchStockForCartItem(item);
      stockQty = stockInfo?.quantityNew;
    }
    if (stockQty === null || stockQty === undefined) {
      toast.error('Unable to verify stock for this item');
      return;
    }

    const currentQty = parseInt(item?.quantity || 0, 10);
    if (stockQty <= 0) {
      toast.error('This item is out of stock');
      return;
    }
    if (currentQty + 1 > stockQty) {
      toast.warning(`Only ${stockQty} items available in stock`);
      return;
    }
    dispatch(updateCartItemQuantity(index, item?.item?.itemNo || item?.item?.recordId));
  };

  const handleQuantityChangeDec = (item, index) => {
    if (item.quantity > 1) {
      dispatch(downgradeCartItemQuantity(index, item?.item?.itemNo || item?.item?.recordId));
    }
  };

  const handleInputFromCalculator = (value) => {
    if (isSplitPayment) return;
    if (isGiftCardPayment) return;

    if (value === 'C') {
      const currentValue = formData?.amountCollected?.toString() || '';
      const newValue = currentValue.slice(0, -1);
      const totalAmountParam = calculateTotalPriceWithTaxesAndDiscounts();
      const numericValue = parseFloat(newValue) || 0;
      const change = numericValue - totalAmountParam;
      setFormData((prevState) => ({
        ...prevState,
        amountCollected: numericValue,
        change: change > 0 ? change : 0,
      }));
    } else {
      const currentValue = formData?.amountCollected?.toString() || '';
      const newValue = parseFloat(currentValue) + parseFloat(value);
      const totalAmountParam = calculateTotalPriceWithTaxesAndDiscounts();
      const numericValue = parseFloat(newValue) || 0;
      const change = numericValue - totalAmountParam;
      setFormData((prevState) => ({
        ...prevState,
        amountCollected: numericValue,
        change: change > 0 ? change : 0,
      }));
    }
  };

  const handleInputChange = (e) => {
    if (isSplitPayment) return;
    if (isGiftCardPayment) return;
    const { name, value } = e.target;
    if (name === 'amountCollected') {
      const totalAmountParam = calculateTotalPriceWithTaxesAndDiscounts();
      const numericValue = parseFloat(value) || 0;
      const change = numericValue - totalAmountParam;
      setFormData((prev) => ({ ...prev, [name]: numericValue, change: change > 0 ? change : 0 }));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleclearCart = () => {
    dispatch(clearCart());
    dispatch(clearTable());
    setSelectedTaxPercentage([]);
    setFormData({ ...formData, customerName: '' });
    setType('');
    dispatch(setOrderType(''));
    setResumedOrderId(null);
    setIsSplitPayment(false);
    setSplitPayments([]);
    setShowSplitModal(false);
    setGiftCardPayments([]);
    resetGiftCardLookup();
    Back();
    onRowSelect(null);
  };

  const lookupGiftCardForRow = async (rowUid) => {
    setSplitPayments((prev) => prev.map((r) => (r.uid === rowUid ? { ...r, giftLookupLoading: true, giftCardData: null } : r)));

    const row = splitPayments.find((r) => r.uid === rowUid);
    const raw = (row?.giftCardCode || '').trim();

    if (!raw) {
      toast.warning('Enter/scan gift card code first.');
      setSplitPayments((prev) => prev.map((r) => (r.uid === rowUid ? { ...r, giftLookupLoading: false } : r)));
      return;
    }

    try {
      const apiService = new ApiService();
      const looksLikeGiftCardCode = /^GC[-_]?/i.test(raw);
      const paramName = looksLikeGiftCardCode ? 'giftCardCode' : 'barcode';

      const res = await apiService.getApiParamater('CHECK_GIFT_CARD', `?${paramName}=${encodeURIComponent(raw)}`);
      const gc = res?.data?.result;

      if (!gc) {
        toast.error('Gift card not found.');
        setSplitPayments((prev) => prev.map((r) => (r.uid === rowUid ? { ...r, giftLookupLoading: false, giftCardData: null } : r)));
        return;
      }

      const balance = getGiftCardBalance(gc);
      const currentAmount = Number(row?.amount) || 0;
      const remainingIncludingThisRow = Math.max(0, splitDueTotal - (splitTotalPaid - currentAmount));
      const maxAllowed = Math.max(0, Math.min(balance, remainingIncludingThisRow));

      setSplitPayments((prev) =>
        prev.map((r) =>
          r.uid === rowUid
            ? {
                ...r,
                giftLookupLoading: false,
                giftCardData: gc,
                giftBalance: balance,
                giftMaxAllowed: maxAllowed,
                amount: r.amount ? r.amount : maxAllowed.toFixed(2),
              }
            : r,
        ),
      );

      toast.success(`Gift card found. Balance ${Currency?.currency?.code} ${balance.toFixed(2)}`);
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || 'Gift card lookup failed.');
      setSplitPayments((prev) => prev.map((r) => (r.uid === rowUid ? { ...r, giftLookupLoading: false } : r)));
    }
  };

  const handleDisable = () => {
    if (cartData?.length > 0 || comboCart?.length > 0) {
      const totalAmount = calculateTotalPriceWithTaxesAndDiscounts();
      setButtonEnable(true);
      setFormData((prev) => ({ ...prev, amountCollected: totalAmount, change: 0 }));
    } else {
      toast.warning('Please add item to process!');
    }
  };

  const handleEnable = () => {
    setButtonEnable(false);
    setResumedOrderId(null);
    setGiftCardPayments([]);
    resetGiftCardLookup();
    setIsSplitPayment(false);
    setSplitPayments([]);
    setShowSplitModal(false);
    Back();
  };

  const handleOrderType = (Type) => {
    dispatch(clearTable());
    dispatch(setOrderType(Type));
    setType(Type);
    handleDisableToggle(Type || 'Dine-In');
  };

  const handlePaymentType = (Type) => {
    if (isSplitPayment) return;
    const id = Number(Type?.id);
    setPaymentType(id);
    if (id === GIFT_CARD_PAYMENT_METHOD_ID) {
      setTimeout(() => giftCardInputRef.current?.focus(), 250);
    }
  };

  const handleSelectedTax = (selectedItem) => {
    setSelectedTaxPercentage(selectedItem || []);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const closeDiscountModal = () => setDiscountModalOpen(false);
  const openDiscountModal = () => {
    if (cartData?.length > 0) setShowPasscodePopup(true);
    else toast.error('No items in the cart to add discount!');
  };
  const handlePasscodeSubmit = (isValid) => {
    if (isValid) {
      setShowPasscodePopup(false);
      setDiscountModalOpen(true);
    }
  };
  const closeTaxModal = () => setTaxModalOpen(false);

  // EFFECTS
  useEffect(() => {
    const isOrderPunchEnabled = Permission?.includes('Order Punch.add') && Permission.includes('Order Punch.query');
    setAreAllButtonsDisabled(!isOrderPunchEnabled);

    const isDiscountDisableX = Permission?.includes('Discount.add') && Permission.includes('Discount.query');
    setDiscountDisable(!isDiscountDisableX);

    const isTaxDisableX = Permission?.includes('Tax.add') && Permission.includes('Tax.query');
    setTaxDisable(!isTaxDisableX);

    const isPaymentAllowLocal = Permission?.includes('Payment.add') && Permission.includes('Payment.query');
    setPaymentAllow(isPaymentAllowLocal);

    const currentDateX = new Date();
    const options = {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    };
    const formattedDate = currentDateX.toLocaleDateString('en-US', options);
    setDateNow(formattedDate);

    if (!tableData || tableData?.length === 0) {
      setType(orderType);
      handleDisableToggle(orderType);
    } else {
      setType('Dine-In');
      handleDisableToggle('Dine-In');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData]);

  useEffect(() => {
    GetMethods();
    setTotalRate(calculateTotalPrice());
    GetCostumer();
    GetTax();
    GetOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData, comboCart]);

  useEffect(() => {
    setFormData((prev) => ({ ...prev, due: orderTotal }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData, selectedTaxPercentage]);

  useEffect(() => {
    if (isSplitPayment && isFlocashPayment) {
      setIsSplitPayment(false);
      setSplitPayments([]);
      setShowSplitModal(false);
      toast.info('Split payment disabled because Flocash is selected.');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PaymentType]);

  const handleCustomerSelect = (selectedOption) => {
    setFormData((prev) => ({ ...prev, customerName: selectedOption }));
  };

  const handleCustomerCreated = async (newCustomerData) => {
    try {
      const newCustomerOption = {
        value: newCustomerData,
        label: `${newCustomerData.name} (${newCustomerData.mobileNumber || newCustomerData.phoneNumber || newCustomerData.email})`,
      };
      setCustomer((prevCustomers) => {
        const exists = prevCustomers.some((customer) => customer.id === newCustomerData.id);
        if (!exists) return [...prevCustomers, newCustomerData];
        return prevCustomers;
      });
      setFormData((prev) => ({ ...prev, customerName: newCustomerOption }));
      GetCostumer().catch((error) => console.warn('Failed to refresh customer list from API:', error));
      handleClose();
      toast.success(`Customer "${newCustomerData.name}" created and selected successfully!`);
    } catch (error) {
      console.error('Error handling customer creation:', error);
      toast.error('Failed to select the new customer. Please select manually.');
    }
  };

  // STYLES
  const containerStyle = {
    minHeight: '78vh',
    backgroundColor: '#f8f9fa',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  };
  const cardStyle = {
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    border: '1px solid #e9ecef',
    transition: 'all 0.2s ease',
  };
  const headerCardStyle = {
    ...cardStyle,
    background: 'linear-gradient(135deg,rgb(120, 102, 234) 0%, #764ba2 100%)',
    color: 'white',
    marginBottom: '20px',
  };

  // COMPUTED VALUES FOR RENDER
  const subtotal = calculateTotalPrice();
  const tax = calculateTotalTax();
  const discount = calculateTotalDiscount();
  const totalAmount = orderTotal;
  const giftCardApplied = giftCardPaidTotal;
  const amountDue = dueAfterGiftCards;

  return (
    <div style={containerStyle} className="p-1">
      {/* Header */}
      <div style={headerCardStyle} className="p-4">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <div className="mb-1" style={{ fontWeight: '600', fontSize: '14px', opacity: '0.9', color: '#fff' }}>
              {dateNow}
            </div>
            <div className="d-flex align-items-center">
              <FaShoppingCart className="me-2" size={16} />
              <span style={{ fontSize: '14px', fontWeight: '500' }}>POS Terminal</span>
            </div>
          </div>
          <div className="text-end">
            <div className="d-flex align-items-center justify-content-end mb-1">
              <FaUser className="me-2" size={14} />
              <span style={{ fontSize: '14px', fontWeight: '500' }}>{userManagement.getUserName(token)}</span>
            </div>
            <div style={{ fontSize: '12px', opacity: '0.8' }}>Cashier</div>
          </div>
        </div>
      </div>

      {/* Payment Methods */}
      {buttonEnable && (
        <div style={cardStyle} className="p-4 mb-4">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h6 className="mb-0 d-flex align-items-center" style={{ fontWeight: '600', color: '#495057' }}>
              <FaReceipt className="me-2" />
              Payment Method
            </h6>

            <div className="form-check d-flex align-items-center gap-2">
              <input
                style={{ padding: '20px' }}
                className="form-check-input"
                type="checkbox"
                checked={isSplitPayment}
                onChange={(e) => {
                  const on = e.target.checked;
                  setIsSplitPayment(on);
                  if (on) setShowSplitModal(true);
                }}
                id="splitPaymentToggle"
              />
              <label className="form-check-label" htmlFor="splitPaymentToggle" style={{ fontWeight: 600 }}>
                Split Payment
              </label>

              {isSplitPayment && (
                <button type="button" className="btn btn-sm btn-outline-primary ms-2" onClick={() => setShowSplitModal(true)}>
                  Split Bill
                </button>
              )}
            </div>
          </div>

          <div className="d-flex gap-3 flex-wrap">
            {paymentMethod?.map((val, key) => (
              <button
                key={key}
                className={`payment-method-btn ${PaymentType === val?.id ? 'active' : ''}`}
                onClick={() => (!isSplitPayment ? handlePaymentType(val) : null)}
                disabled={isSplitPayment}
                style={{
                  padding: '12px 20px',
                  border: PaymentType === val?.id ? '2px solid #007bff' : '2px solid #e9ecef',
                  borderRadius: '8px',
                  backgroundColor: PaymentType === val?.id ? '#e3f2fd' : 'white',
                  color: PaymentType === val?.id ? '#007bff' : '#6c757d',
                  fontWeight: '500',
                  fontSize: '14px',
                  cursor: isSplitPayment ? 'not-allowed' : 'pointer',
                  opacity: isSplitPayment ? 0.6 : 1,
                  transition: 'all 0.2s ease',
                  minWidth: '120px',
                }}
              >
                {val?.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Main Content */}
      {buttonEnable === false ? (
        <>
          <div style={{ ...cardStyle, display: 'flex', flexDirection: 'column', height: '100%' }} className="mb-4">
            {displayCartItems?.length < 1 ? (
              <>
                <div className="text-center py-5">
                  <img src={NoItem} alt="No items" style={{ maxWidth: '200px', opacity: '0.7' }} />
                  <h5 className="mt-3 text-muted">Your cart is empty</h5>
                  <p className="text-muted">Add items to get started</p>
                </div>
                <div className="row g-3 mt-2">
                  <div className="col-md-6">
                    <button
                      onClick={handleHoldPayment}
                      className="btn w-100"
                      style={{
                        backgroundColor: '#6e5199',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '8px',
                        padding: '12px',
                        fontSize: '14px',
                        fontWeight: '600',
                      }}
                    >
                      <FaClock className="me-2" />
                      Suspend Sale
                    </button>
                  </div>
                  <div className="col-md-6">
                    <button
                      onClick={() => setIsHeldModalOpen(true)}
                      className="btn w-100"
                      style={{
                        backgroundColor: '#6c757d',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        padding: '12px',
                        fontSize: '14px',
                        fontWeight: '600',
                      }}
                    >
                      <FaArchive className="me-2" />
                      Resume Sale
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="p-4 border-bottom" style={{ flexShrink: 0 }}>
                  <h6 className="mb-0 d-flex align-items-center" style={{ fontWeight: '600', color: '#495057' }}>
                    <FaShoppingCart className="me-2" />
                    Cart Items ({displayCartItems.length})
                  </h6>
                </div>

                <div
                  className="table-responsive"
                  style={{
                    height: displayCartItems.length > 3 ? '180px' : 'auto',
                    maxHeight: '300px',
                    overflowY: displayCartItems.length > 3 ? 'auto' : 'visible',
                    overflowX: 'hidden',
                  }}
                >
                  <table className="table mb-0">
                    <thead
                      style={{
                        backgroundColor: '#f8f9fa',
                        position: 'sticky',
                        top: 0,
                        zIndex: 10,
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                      }}
                    >
                      <tr>
                        <th style={{ padding: '16px', fontWeight: '600', fontSize: '14px', color: '#495057', border: 'none' }}>Item</th>
                        <th style={{ padding: '16px', fontWeight: '600', fontSize: '14px', color: '#495057', border: 'none' }}>Variant</th>
                        <th style={{ padding: '16px', fontWeight: '600', fontSize: '14px', color: '#495057', border: 'none', textAlign: 'center' }}>
                          Quantity
                        </th>
                        <th style={{ padding: '16px', fontWeight: '600', fontSize: '14px', color: '#495057', border: 'none', textAlign: 'right' }}>Total</th>
                        <th style={{ padding: '16px', fontWeight: '600', fontSize: '14px', color: '#495057', border: 'none', textAlign: 'center' }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {displayCartItems.map((item, index) => {
                        const isGift = !!(item?.isGiftCard || item?.item?.isGiftCard || item?.itemData?.isGiftCard);
                        const title =
                          item?.name ||
                          item?.item?.itemName ||
                          item?.item?.itemDescription ||
                          item?.itemData?.itemName ||
                          item?.itemData?.itemDescription ||
                          'Item';
                        const itemPrice = calculateItemPrice(item);
                        const itemTotal = itemPrice * item.quantity;
                        const materialNo = getMaterialNoFromCartItem(item);
                        const cachedStockQty = getCachedStockQty(item);
                        const isCheckingStockItem = stockLoadingMap[materialNo];
                        const stockError = stockErrorMap[materialNo];
                        const outOfStock = cachedStockQty !== null && cachedStockQty !== undefined && cachedStockQty <= 0;
                        const atMax = cachedStockQty !== null && cachedStockQty !== undefined && item.quantity >= cachedStockQty;
                        const itemDiscount = getLineDiscount(item);
                        const isDisc = isOrderLevelDiscount(item);
                        const disableQty = isGift || isDisc;

                        return (
                          <tr
                            key={index}
                            onClick={() => onRowSelect?.(item)}
                            style={{ cursor: 'pointer', transition: 'background-color 0.2s ease' }}
                            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f8f9fa')}
                            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
                          >
                            <td style={{ padding: '16px', borderBottom: '1px solid #f1f3f4' }}>
                              <div>
                                <div style={{ fontWeight: '600', fontSize: '14px', color: '#212529', marginBottom: '4px' }}>
                                  {title || item?.item?.itemName}
                                </div>
                                {itemDiscount > 0 && (
                                  <div className="d-flex align-items-center">
                                    <TbFlagDiscount size={14} className="me-1 text-success" />
                                    <span style={{ fontSize: '12px', color: '#28a745', fontWeight: '500' }}>
                                      {item?.discountType === 'Percentage' ? `${item?.discount}% off` : `${Currency?.currency?.code} ${item?.discount} off`}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </td>

                            <td style={{ padding: '16px', borderBottom: '1px solid #f1f3f4' }}>
                              {item?.selectedVariant?.itemDescription && (
                                <span style={{ fontSize: '13px', color: '#6c757d', fontStyle: 'italic' }}>{item.selectedVariant.itemDescription}</span>
                              )}
                            </td>

                            <td style={{ padding: '16px', borderBottom: '1px solid #f1f3f4', textAlign: 'center' }}>
                              <div className="d-flex align-items-center justify-content-center">
                                <button
                                  className="btn-quantity"
                                  disabled={disableQty}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (disableQty) return;
                                    handleQuantityChangeDec(item, index);
                                  }}
                                  style={{
                                    width: '32px',
                                    height: '32px',
                                    border: '1px solid #dee2e6',
                                    borderRadius: '6px',
                                    backgroundColor: 'white',
                                    color: '#6c757d',
                                    cursor: disableQty ? 'not-allowed' : 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    transition: 'all 0.2s ease',
                                    opacity: disableQty ? 0.5 : 1,
                                  }}
                                >
                                  <FaMinus size={10} />
                                </button>
                                <span style={{ margin: '0 16px', fontWeight: '600', fontSize: '16px', minWidth: '24px', textAlign: 'center' }}>
                                  {disableQty ? '-' : item.quantity}
                                </span>
                                <button
                                  className="btn-quantity"
                                  disabled={outOfStock || atMax || true}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (disableQty) return;
                                    handleQuantityChange(item, index);
                                  }}
                                  style={{
                                    width: '32px',
                                    height: '32px',
                                    border: '1px solid #dee2e6',
                                    borderRadius: '6px',
                                    backgroundColor: 'white',
                                    color: '#6c757d',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    transition: 'all 0.2s ease',
                                    cursor: disableQty ? 'not-allowed' : 'pointer',
                                    opacity: disableQty ? 0.5 : 1,
                                  }}
                                >
                                  <FaPlus size={10} />
                                </button>
                              </div>
                            </td>

                            <td style={{ padding: '16px', borderBottom: '1px solid #f1f3f4', textAlign: 'right' }}>
                              <div style={{ fontWeight: '600', fontSize: '15px', color: '#212529' }}>
                                {Currency?.currency?.code} {(itemTotal - itemDiscount * item.quantity).toFixed(2)}
                              </div>
                            </td>

                            <td style={{ padding: '16px', borderBottom: '1px solid #f1f3f4', textAlign: 'center' }}>
                              <div className="d-flex justify-content-center gap-2">
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDelete(item?.item?.itemNo || item?.item?.recordId, index);
                                  }}
                                  style={{
                                    width: '32px',
                                    height: '32px',
                                    border: '1px solid #ffc107',
                                    borderRadius: '6px',
                                    backgroundColor: '#fff3cd',
                                    color: '#856404',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.2s ease',
                                  }}
                                >
                                  <Delete width={16} height={16} />
                                </button>

                                <button
                                  onClick={(e) => {
                                    if (isDisc) return;
                                    e.stopPropagation();
                                    setIsEditModalOpen(true);
                                    setSelectedCartItem({ ...item, __index: index });
                                  }}
                                  disabled={isDisc}
                                  style={{
                                    opacity: isDisc ? 0.4 : 1,
                                    width: '32px',
                                    height: '32px',
                                    border: '1px solid #17a2b8',
                                    borderRadius: '6px',
                                    backgroundColor: '#d1ecf1',
                                    color: '#0c5460',
                                    cursor: isDisc ? 'not-allowed' : 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.2s ease',
                                  }}
                                >
                                  <BiEdit size={16} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {/* Cart Summary */}
                <div className="p-4 border-top" style={{ backgroundColor: '#f8f9fa', flexShrink: 0 }}>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="row g-3">
                        <div className="col-6">
                          <div className="text-center">
                            <div style={{ fontSize: '24px', fontWeight: '700', color: '#212529' }}>{displayCartItems.length}</div>
                            <div style={{ fontSize: '12px', color: '#6c757d', fontWeight: '500' }}>Items</div>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="text-center">
                            <div style={{ fontSize: '24px', fontWeight: '700', color: '#212529' }}>
                              {displayCartItems.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0)}
                            </div>
                            <div style={{ fontSize: '12px', color: '#6c757d', fontWeight: '500' }}>Quantity</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="text-end">
                        <div style={{ fontSize: '14px', color: '#6c757d', marginBottom: '4px' }}>
                          Subtotal: {Currency?.currency?.code} {subtotal.toFixed(2)}
                        </div>
                        {tax > 0 && (
                          <div style={{ fontSize: '14px', color: '#6c757d', marginBottom: '4px' }}>
                            Tax: {Currency?.currency?.code} {tax.toFixed(2)}
                          </div>
                        )}
                        {discount > 0 && (
                          <div style={{ fontSize: '14px', color: '#28a745', marginBottom: '8px' }}>
                            Discount: -{Currency?.currency?.code} {discount.toFixed(2)}
                          </div>
                        )}
                        <div style={{ fontSize: '22px', fontWeight: '700', color: '#212529' }}>
                          {Currency?.currency?.code} {totalAmount.toFixed(2)}
                        </div>
                        <div style={{ fontSize: '12px', color: '#6c757d', fontWeight: '500' }}>Total Amount</div>
                        {giftCardApplied > 0 && (
                          <div className="mt-2">
                            <div style={{ fontSize: '14px', color: '#0c5460', marginBottom: '4px', fontWeight: 600 }}>
                              Gift Card Applied: -{Currency?.currency?.code} {giftCardApplied.toFixed(2)}
                            </div>
                            <div style={{ fontSize: '22px', fontWeight: '800', color: '#212529' }}>
                              {Currency?.currency?.code} {amountDue.toFixed(2)}
                            </div>
                            <div style={{ fontSize: '12px', color: '#6c757d', fontWeight: '600' }}>Amount Due</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="p-4 border-top" style={{ flexShrink: 0 }}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <button
                        onClick={handleDisable}
                        className="btn w-100"
                        style={{
                          backgroundColor: '#6e5199',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          padding: '14px',
                          fontSize: '16px',
                          fontWeight: '600',
                        }}
                      >
                        <FaReceipt className="me-2" />
                        Pay Order
                      </button>
                    </div>
                    <div className="col-md-6">
                      <button
                        onClick={handleclearCart}
                        className="btn w-100"
                        style={{
                          backgroundColor: '#dc3545',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          padding: '14px',
                          fontSize: '16px',
                          fontWeight: '600',
                        }}
                      >
                        Clear Cart
                      </button>
                    </div>
                  </div>

                  <div className="row g-3 mt-2">
                    <div className="col-md-6">
                      <button
                        onClick={handleHoldPayment}
                        className="btn w-100"
                        style={{
                          backgroundColor: '#6e5199',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '8px',
                          padding: '12px',
                          fontSize: '14px',
                          fontWeight: '600',
                        }}
                      >
                        <FaClock className="me-2" />
                        Suspend Sale
                      </button>
                    </div>
                    <div className="col-md-6">
                      <button
                        onClick={() => setIsHeldModalOpen(true)}
                        className="btn w-100"
                        style={{
                          backgroundColor: '#6c757d',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          padding: '12px',
                          fontSize: '14px',
                          fontWeight: '600',
                        }}
                      >
                        <FaArchive className="me-2" />
                        Resume Sale
                      </button>
                    </div>
                  </div>

                  <div className="row g-3 mt-2">
                    <div className="col-md-6">
                      <button
                        onClick={openDiscountModal}
                        className="btn w-100"
                        style={{
                          backgroundColor: '#6e5199',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          padding: '10px',
                          fontSize: '14px',
                          fontWeight: '500',
                        }}
                      >
                        <TbFlagDiscount className="me-2" />
                        Add Discount
                      </button>
                    </div>
                    {!areTaxDisable && (
                      <div className="col-md-6">
                        <button
                          onClick={() => setTaxModalOpen(true)}
                          className="btn w-100"
                          style={{
                            backgroundColor: '#6f42c1',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            padding: '10px',
                            fontSize: '14px',
                            fontWeight: '500',
                          }}
                        >
                          <HiOutlineTag className="me-2" />
                          Add Tax
                        </button>
                      </div>
                    )}
                  </div>

                  <div className="row g-3 mt-2">
                    <div className="col-md-12">
                      <button
                        onClick={handleOpenCashDrawer}
                        className="btn w-100"
                        style={{
                          backgroundColor: '#343a40',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          padding: '10px',
                          fontSize: '14px',
                          fontWeight: '500',
                        }}
                      >
                        💵 Open Cash Drawer
                      </button>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      ) : (
        // ===================== PAYMENT SCREEN =====================
        <div style={cardStyle} className="p-4">
          <div className="mb-4">
            <h5 className="d-flex align-items-center mb-0" style={{ fontWeight: '600', color: '#495057' }}>
              <FaReceipt className="me-2" />
              Payment Processing
            </h5>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <div className="row g-4">
                <div className="col-12">
                  <label className="form-label" style={{ fontWeight: '600', color: '#495057', marginBottom: '8px' }}>
                    Total Amount
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={`${Currency?.currency?.code} ${totalAmount.toFixed(2)}`}
                    disabled
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #dee2e6',
                      borderRadius: '8px',
                      padding: '12px 16px',
                      fontSize: '16px',
                      fontWeight: '600',
                    }}
                  />
                </div>

                {giftCardApplied > 0 && (
                  <div className="col-12">
                    <label className="form-label" style={{ fontWeight: '600', color: '#495057', marginBottom: '8px' }}>
                      Gift Card Applied
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={`-${Currency?.currency?.code} ${giftCardApplied.toFixed(2)}`}
                      disabled
                      style={{
                        backgroundColor: '#e8f5e9',
                        border: '1px solid #c8e6c9',
                        borderRadius: '8px',
                        padding: '12px 16px',
                        fontSize: '16px',
                        fontWeight: '700',
                        color: '#1b5e20',
                      }}
                    />
                  </div>
                )}

                <div className="col-12">
                  <div className="d-flex align-items-center justify-content-between">
                    <label className="form-label" style={{ fontWeight: '600', color: '#495057', marginBottom: '8px' }}>
                      Amount Collected
                    </label>
                    {isSplitPayment && (
                      <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setShowSplitModal(true)}>
                        Split Bill
                      </button>
                    )}
                  </div>

                  <input
                    type="number"
                    className="form-control"
                    name="amountCollected"
                    value={
                      isSplitPayment
                        ? Number((splitTotalPaid || 0).toFixed(2))
                        : isGiftCardPayment
                          ? Number((giftCardApplied || 0).toFixed(2))
                          : isEditingAmount
                            ? (formData.amountCollected ?? '')
                            : (formData.amountCollected ?? totalAmount)
                    }
                    onChange={(e) => {
                      if (isSplitPayment) return;
                      setIsEditingAmount(true);
                      handleInputChange(e);
                    }}
                    step="0.01"
                    min="0"
                    disabled={isSplitPayment || isGiftCardPayment}
                    style={{
                      border: '2px solid #dee2e6',
                      borderRadius: '8px',
                      padding: '12px 16px',
                      fontSize: '16px',
                      transition: 'border-color 0.2s ease',
                      backgroundColor: isSplitPayment || isGiftCardPayment ? '#f8f9fa' : 'white',
                    }}
                  />
                  {isGiftCardPayment && (
                    <div className="small text-muted mt-1">Gift Card mode: redeem below. If remaining exists, split payment will be used.</div>
                  )}
                </div>

                <div className="col-12">
                  <label className="form-label" style={{ fontWeight: '600', color: '#495057', marginBottom: '8px' }}>
                    Amount Return
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    value={(formData.change || 0).toFixed(2)}
                    disabled
                    style={{
                      backgroundColor: formData.change > 0 ? '#d4edda' : '#f8f9fa',
                      border: `1px solid ${formData.change > 0 ? '#c3e6cb' : '#dee2e6'}`,
                      borderRadius: '8px',
                      padding: '12px 16px',
                      fontSize: '16px',
                      fontWeight: '600',
                      color: formData.change > 0 ? '#155724' : '#6c757d',
                    }}
                  />
                </div>

                {isAccountPayment && !isSplitPayment && !isGiftCardPayment && (
                  <div className="col-12">
                    <label className="form-label" style={{ fontWeight: '600', color: '#495057', marginBottom: '8px' }}>
                      Reference Number
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="accountNumber"
                      value={formData.accountNumber || ''}
                      onChange={handleInputChange}
                      placeholder="Enter reference number"
                      style={{ border: '2px solid #dee2e6', borderRadius: '8px', padding: '10px 14px', fontSize: '14px' }}
                    />
                  </div>
                )}

                {isEftPayment && !isSplitPayment && !isGiftCardPayment && (
                  <div className="col-12">
                    <label className="form-label" style={{ fontWeight: '600', color: '#495057', marginBottom: '8px' }}>
                      EFT Reference Code
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="eftReference"
                      value={formData.eftReference || ''}
                      onChange={handleInputChange}
                      placeholder="Bank / EFT reference"
                      style={{ border: '2px solid #dee2e6', borderRadius: '8px', padding: '10px 14px', fontSize: '14px' }}
                    />
                  </div>
                )}

                {/* Gift Card Redeem */}
                {isGiftCardPayment && (
                  <div className="col-12">
                    <div className="p-3 border rounded" style={{ backgroundColor: '#f8f9fa' }}>
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div style={{ fontWeight: 800, color: '#495057' }}>Redeem Gift Card</div>
                        <div className="small text-muted">
                          Remaining:{' '}
                          <b>
                            {Currency?.currency?.code} {amountDue.toFixed(2)}
                          </b>
                        </div>
                      </div>

                      <div className="d-flex gap-2 mb-2">
                        <input
                          ref={giftCardInputRef}
                          type="text"
                          className="form-control"
                          value={giftCardCode}
                          onChange={(e) => onGiftCardInputChange(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              lookupGiftCard(e.currentTarget.value);
                            }
                          }}
                          placeholder="Scan barcode or enter code"
                        />
                        <button type="button" className="btn btn-primary" disabled={giftCardLookupLoading} onClick={() => lookupGiftCard(giftCardCode)}>
                          {giftCardLookupLoading ? 'Searching...' : 'Lookup'}
                        </button>
                      </div>

                      {giftCardData && (
                        <div className="border rounded p-3 bg-white">
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <div style={{ fontWeight: 800 }}>Card Found</div>
                              <div className="small text-muted">Code: {(giftCardData?.giftCardCode || giftCardCode || '').trim()}</div>
                            </div>
                            <div style={{ fontWeight: 800 }}>
                              Balance: {Currency?.currency?.code} {getGiftCardBalance(giftCardData).toFixed(2)}
                            </div>
                          </div>

                          <div className="mt-3">
                            <label className="form-label fw-bold">Amount to Use</label>
                            <div className="d-flex gap-2">
                              <input
                                type="number"
                                className="form-control"
                                min="0"
                                step="0.01"
                                value={giftCardRedeemAmount}
                                onChange={(e) => setGiftCardRedeemAmount(e.target.value)}
                              />
                              <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => {
                                  const balance = getGiftCardBalance(giftCardData);
                                  const max = Math.max(0, Math.min(balance, eligibleRemaining, amountDue));
                                  setGiftCardRedeemAmount(max.toFixed(2));
                                }}
                              >
                                Use Max
                              </button>
                              <button type="button" className="btn btn-success" onClick={applyGiftCardPayment}>
                                Apply
                              </button>
                            </div>
                            <div className="small text-muted mt-2">Tip: If remaining is left after applying, split payment will be used.</div>
                          </div>
                        </div>
                      )}

                      {giftCardPayments.length > 0 && (
                        <div className="mt-3">
                          <div className="fw-bold mb-2">Applied Gift Cards</div>
                          {giftCardPayments.map((g, idx) => (
                            <div key={`${g.giftCardCode}-${idx}`} className="d-flex justify-content-between align-items-center small py-1">
                              <span>{g.giftCardCode}</span>
                              <div className="d-flex align-items-center gap-2">
                                <span className="text-success fw-bold">
                                  -{Currency?.currency?.code} {Number(g.redeemAmount || 0).toFixed(2)}
                                </span>
                                <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => removeGiftCardPayment(g.giftCardCode)}>
                                  Remove
                                </button>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {!isGiftCardPayment && (
                  <div className="col-12">
                    <label className="form-label" style={{ fontWeight: '600', color: '#495057', marginBottom: '8px' }}>
                      Customer
                    </label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        value={formData.customerName?.label || ''}
                        disabled
                        style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '8px 0 0 8px', padding: '12px 16px' }}
                      />
                      <button
                        className="btn"
                        onClick={() => setShow(true)}
                        style={{ backgroundColor: '#007bff', color: 'white', border: '1px solid #007bff', borderRadius: '0 8px 8px 0', padding: '12px 16px' }}
                      >
                        <MdPersonAddAlt1 size={18} />
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="col-lg-6">
              <Calculator handleInput={handleInputFromCalculator} />
              {isSplitPayment && (
                <div className="mt-3 small text-muted">
                  Split mode is enabled. Use <b>Split Bill</b> to edit amounts.
                </div>
              )}
            </div>
          </div>

          <div className="row g-3 mt-4">
            <div className="col-md-6">
              <button
                className="btn w-100"
                onClick={handleEnable}
                style={{
                  backgroundColor: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '14px',
                  fontSize: '16px',
                  fontWeight: '600',
                }}
              >
                <BackArrow className="me-2" width={16} />
                Back to Cart
              </button>
            </div>
            <div className="col-md">
              <button
                onClick={handleOpenCashDrawer}
                className="btn w-100"
                style={{
                  backgroundColor: '#343a40',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '15px',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
              >
                💵 Open Cash Drawer
              </button>
            </div>
          </div>

          <div className="row g-3 mt-2">
            <div className="col-md-12 d-flex gap-2">
              <button
                onClick={placeOrderNoPrint}
                className={`btn w-100 ${!isPaymentFormValid || isPlacingOrder ? 'disabled' : ''}`}
                disabled={!isPaymentFormValid || isPlacingOrder}
                style={{
                  backgroundColor: !isPaymentFormValid || isPlacingOrder ? '#e9ecef' : '#17a2b8',
                  color: !isPaymentFormValid || isPlacingOrder ? '#6c757d' : 'white',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '14px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: !isPaymentFormValid || isPlacingOrder ? 'not-allowed' : 'pointer',
                }}
              >
                {isPlacingOrder ? <div className="spinner-border spinner-border-sm me-2" role="status"></div> : <FaReceipt className="me-2" />}
                {isPlacingOrder ? 'Processing...' : 'Complete (No Print)'}
              </button>

              <button
                onClick={placeOrder}
                className={`btn w-100 ${!isPaymentFormValid || isPlacingOrder ? 'disabled' : ''}`}
                disabled={!isPaymentFormValid || isPlacingOrder}
                style={{
                  backgroundColor: !isPaymentFormValid || isPlacingOrder ? '#e9ecef' : '#28a745',
                  color: !isPaymentFormValid || isPlacingOrder ? '#6c757d' : 'white',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '14px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: !isPaymentFormValid || isPlacingOrder ? 'not-allowed' : 'pointer',
                }}
              >
                {isPlacingOrder ? <div className="spinner-border spinner-border-sm me-2" role="status"></div> : <FaReceipt className="me-2" />}
                {isPlacingOrder ? 'Processing...' : 'Complete Order'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===================== SPLIT PAYMENT MODAL ===================== */}
      <Modal show={showSplitModal} onHide={() => setShowSplitModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Split Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {splitPayments.map((row, idx) => {
            const methodId = Number(row.methodId);
            const isGift = isGiftCardMethod(methodId);

            return (
              <div key={row.uid} className="border rounded p-3 mb-3">
                <div className="row g-3 align-items-end">
                  <div className="col-md-5">
                    <label className="form-label fw-bold">Method</label>
                    <Select
                      value={splitMethodOptions.find((o) => o.value === methodId) || null}
                      onChange={(opt) => {
                        const v = Number(opt?.value || 0) || null;
                        setSplitPayments((prev) =>
                          prev.map((p, i) =>
                            i === idx
                              ? {
                                  ...p,
                                  methodId: v,
                                  amount: '',
                                  eftReference: '',
                                  accountNumber: '',
                                  giftCardCode: '',
                                  giftLookupLoading: false,
                                  giftCardData: null,
                                  giftBalance: 0,
                                  giftMaxAllowed: 0,
                                }
                              : p,
                          ),
                        );
                      }}
                      options={splitMethodOptions}
                      placeholder="Select method"
                    />
                  </div>

                  <div className="col-md-4">
                    {isGift && <div className="small text-muted mt-1">Scan/lookup sets balance. Amount ≤ balance and ≤ remaining due.</div>}
                    <label className="form-label fw-bold">Amount {isGift && row.giftMaxAllowed > 0 ? `(max ${row.giftMaxAllowed.toFixed(2)})` : ''}</label>
                    <input
                      type="number"
                      className="form-control"
                      value={row.amount ?? ''}
                      min="0"
                      step="0.01"
                      onChange={(e) => {
                        const v = e.target.value;
                        setSplitPayments((prev) =>
                          prev.map((p, i) => {
                            if (i !== idx) return p;
                            if (isGift) {
                              const num = Number(v) || 0;
                              const max = Number(p.giftMaxAllowed) || 0;
                              if (max > 0 && num > max + 0.01) {
                                return { ...p, amount: max.toFixed(2) };
                              }
                            }
                            return { ...p, amount: v };
                          }),
                        );
                      }}
                    />
                  </div>

                  <div className="col-md-3 d-flex justify-content-end gap-2">
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      onClick={() => {
                        const paidOther = splitPayments.reduce((s, p, i) => s + (i === idx ? 0 : Number(p.amount) || 0), 0);
                        const remaining = Math.max(0, splitDueTotal - paidOther);
                        setSplitPayments((prev) =>
                          prev.map((p, i) => {
                            if (i !== idx) return p;
                            if (isGift) {
                              const max = Number(p.giftMaxAllowed) || 0;
                              const val = max > 0 ? Math.min(remaining, max) : remaining;
                              return { ...p, amount: val.toFixed(2) };
                            }
                            return { ...p, amount: remaining.toFixed(2) };
                          }),
                        );
                      }}
                    >
                      Remaining
                    </button>
                    <button
                      className="btn btn-danger"
                      type="button"
                      disabled={splitPayments.length === 1}
                      onClick={() => setSplitPayments((prev) => prev.filter((_, i) => i !== idx))}
                    >
                      Remove
                    </button>
                  </div>

                  {isGift && (
                    <div className="col-12">
                      <div className="p-3 bg-light rounded">
                        <div className="row g-2 align-items-end">
                          <div className="col-md-8">
                            <label className="form-label fw-bold">Gift Card Code / Barcode</label>
                            <input
                              type="text"
                              className="form-control"
                              value={row.giftCardCode || ''}
                              onChange={(e) => {
                                const v = e.target.value;
                                setSplitPayments((prev) => prev.map((p) => (p.uid === row.uid ? { ...p, giftCardCode: v } : p)));
                              }}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  e.preventDefault();
                                  lookupGiftCardForRow(row.uid);
                                }
                              }}
                              placeholder="Scan or enter"
                            />
                          </div>
                          <div className="col-md-4">
                            <button
                              type="button"
                              className="btn btn-primary w-100"
                              disabled={row.giftLookupLoading}
                              onClick={() => lookupGiftCardForRow(row.uid)}
                            >
                              {row.giftLookupLoading ? 'Searching...' : 'Lookup'}
                            </button>
                          </div>
                          {row.giftCardData && (
                            <div className="col-12 mt-2">
                              <div className="d-flex justify-content-between">
                                <div className="small">
                                  <b>Valid</b> — {row.giftCardData?.giftCardCode || row.giftCardCode}
                                </div>
                                <div className="small">
                                  Balance:{' '}
                                  <b>
                                    {Currency?.currency?.code} {Number(row.giftBalance || 0).toFixed(2)}
                                  </b>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}

          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={() =>
              setSplitPayments((prev) => [
                ...prev,
                {
                  uid: Date.now() + Math.random(),
                  methodId: 1,
                  amount: '',
                  eftReference: '',
                  accountNumber: '',
                  giftCardCode: '',
                  giftLookupLoading: false,
                  giftCardData: null,
                  giftBalance: 0,
                  giftMaxAllowed: 0,
                },
              ])
            }
          >
            + Add Payment
          </button>

          <div className="mt-4 p-3 bg-light rounded">
            <div className="d-flex justify-content-between">
              <div>
                <b>Total Due</b>
              </div>
              <div>
                {Currency?.currency?.code} {splitDueTotal.toFixed(2)}
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <div>
                <b>Total Entered</b>
              </div>
              <div>
                {Currency?.currency?.code} {splitTotalPaid.toFixed(2)}
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <div>
                <b>Remaining</b>
              </div>
              <div>
                {Currency?.currency?.code} {Math.max(0, splitDueTotal - splitTotalPaid).toFixed(2)}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setShowSplitModal(false)}>
            Close
          </button>
          <button
            className="btn btn-success"
            onClick={() => {
              if (!validateSplitPayments(false)) return;
              setShowSplitModal(false);
            }}
          >
            Save Split
          </button>
        </Modal.Footer>
      </Modal>

      {/* Edit Modal */}
      <Modal show={isEditModalOpen} onHide={() => setIsEditModalOpen(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Edit Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isGiftCardLine || isGiftCardMode ? (
            <GiftCardModal
              item={selectedCartItem?.item}
              closeModal={() => setIsEditModalOpen(false)}
              isEdit={true}
              editingItem={selectedCartItem}
              Currency={Currency}
            />
          ) : (
            <CartPopup
              CartValue={selectedCartItem?.item}
              selectedAdOn={selectedCartItem?.selectedAdOn}
              selectedModifier={selectedCartItem?.selectedModifier}
              selectedVariant={selectedCartItem?.selectedVariant}
              closeModal={() => setIsEditModalOpen(false)}
              isEdit={true}
              editingItem={selectedCartItem}
              Currency={Currency}
            />
          )}
        </Modal.Body>
      </Modal>

      {showPasscodePopup && <PasscodePopup onSubmit={handlePasscodeSubmit} onClose={() => setShowPasscodePopup(false)} />}
      {discountModal && <DiscountModal closeDiscountModal={closeDiscountModal} />}

      <Modal show={TaxModal} onHide={closeTaxModal} size="md">
        <Modal.Header closeButton>
          <Modal.Title className="center">Add Tax</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Select
            isMulti
            options={taxes?.map((tax) => ({ value: tax, label: tax?.name }))}
            value={selectedTaxPercentage}
            onChange={handleSelectedTax}
            isClearable
          />
        </Modal.Body>
        <Modal.Footer className="end p-3">
          <button className="AddBtn" onClick={closeTaxModal}>
            Save
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Customer</Modal.Title>
        </Modal.Header>
        <div className="p-4">
          <div className="mb-3">
            <CreatableSelect
              isMulti={false}
              options={Customers?.map((Items) => ({
                value: Items,
                label: `${Items.name} (${Items.mobileNumber || Items.phoneNumber})`,
              }))}
              value={formData?.customerName}
              onChange={handleCustomerSelect}
              placeholder="Select or search customer..."
              isClearable
              onCreateOption={(inputValue) => {
                console.log('Create new customer:', inputValue);
              }}
            />
          </div>
          <CustomerCreatePOpup
            orderType={orderType}
            GetCostumer={GetCostumer}
            close={handleClose}
            selectedCustomer={formData?.customerName || { value: null }}
            address={formData?.address}
            onCustomerCreated={handleCustomerCreated}
          />
        </div>
      </Modal>

      <Modal show={isHeldModalOpen} onHide={() => setIsHeldModalOpen(false)} size="sm">
        <Modal.Header closeButton>
          <Modal.Title>Held Orders</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="p-3">
            {heldOrders?.length === 0 ? (
              <p className="text-center text-muted">No held orders found</p>
            ) : (
              heldOrders?.map((heldOrder, index) => (
                <div className="p-3 mb-2 border rounded cursor-pointer" key={index} onClick={() => handleHeldOrder(heldOrder)} style={{ cursor: 'pointer' }}>
                  <div className="d-flex justify-content-between">
                    <div>
                      <strong>Order #{heldOrder.id}</strong>
                      <div className="text-muted small">{new Date(heldOrder.orderDate).toLocaleString()}</div>
                      <div className="text-muted small">Items: {heldOrder.orderItems?.length || 0}</div>
                    </div>
                    <div className="text-end">
                      <div className="h6">
                        {Currency?.currency?.code} {Number(heldOrder.orderAmount || 0).toFixed(2)}
                      </div>
                      <div className="text-muted small">{heldOrder.customerName || 'Guest'}</div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

const mapStatetoProps = (state) => state;
const mapDispatchToProps = { updateCartItemQuantity };

export default connect(mapStatetoProps, mapDispatchToProps)(CashierBucket);
